import React, { useCallback, useEffect, useRef, useState } from 'react';
import styles from './ProjectData.module.css';
import { useNavigate } from 'react-router-dom';
import { Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react';
import Overview from './components/Overview';
import { useLocation } from 'react-router-dom';
import LiveData from './components/LiveData';
import Day1 from './components/Day1';
import portlessProxy from 'bareproxy';
import Channels from './components/Channels';
import NewPage from './components/NewPage';
import {
  DeviceController,
  DeviceEnergyMeter,
  DeviceFlowMeter,
  DeviceIO,
  Devices,
  DeviceDisplay,
  // Indicator,
} from './components/Devices';
import tableInitWorker from 'Utils/restructure.worker';
import WorkerBuilder from 'Utils/builder.worker';
import valueExtractorWorker from 'Utils/valueExtractor.worker';
import oneDayDataRestructureWorker from 'Utils/oneDay.worker';
import { PieChart } from './components/PieChart';
import { BarChart } from './components/BarChart';
import { Histogram } from './components/Histogram';
import { LineChart } from './components/LineChart';
import { Gauge } from './components/Gauge';
import { ProgressBar } from './components/ProgressBar';
import { ToolBarGrid } from './components/ToolBarGrid';
import { MovableTable } from 'components/MovableTable/MovableTable';
import { useDispatch, useSelector } from 'react-redux';
import {
  getGraphData,
  getWidgetData,
} from '../../../../redux/slices/viewDataSlice.js';
import motorgif from '../../../../assets/motorgif.gif';
import {
  getMqttCredentials,
  getProjectSetting,
} from '../../../../redux/slices/projectSetting';

import { fetchTagGroups } from '../../../../redux/slices/tagGroupSlice';
import { CircularProgressChart } from './components/CircularProgress';
import { DoughnutChart } from './components/DoughnutChart';
import { Stage, Layer, Line, Circle } from 'react-konva';
import CustomSwitch from './components/NewPage/components/CustomSwitch';
import { Slider } from './components/NewPage/components/Slider';
import LampON from '../../../../assets/LampON.svg';
import LampOFF from '../../../../assets/LampOFF.svg';
import Konva from 'konva';
import Clock from './components/NewPage/components/Clock';
import BulbIcon from 'components/BulbIcon';
import {
  handleChangeSV,
  handleDoubleClick,
  handleWidgetDoubleClick,
} from './components/NewPage/WidgetDoubleClickFunction';
import {
  ChangeSVModal,
  ChangeValueModal,
} from './components/NewPage/components/Popups';
import { useToast } from '@chakra-ui/react';
import { buildTagMap, vNetLogin } from '../../../../redux/slices/vNetSlice';
import CryptoJS from 'crypto-js';
import proxy from 'proxy';

const tableInitializer = new WorkerBuilder(tableInitWorker);
const valueExtractor = new WorkerBuilder(valueExtractorWorker);
const restructureWorker = new WorkerBuilder(oneDayDataRestructureWorker);

const io = require('socket.io-client');

function Project({ setPage }) {
  setPage('dashboard');
  const userPermission = useSelector(
    (state) => state.organization.userPermission,
  );

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const uniqueProjectId = searchParams.get('graphId');
  const [tableData, setTableData] = useState([]); // Data formatted for Table
  const [init, setInit] = useState(false);
  const [isWorkerBusy, setIsWorkerBusy] = useState(false);
  const [dateTimesLive, setDateTimesLive] = useState([]); // DateTime labels for y-axis
  const [dataArrLive, setDataArrLive] = useState([]); // Real-time data received for live
  const [channelNames, setChannelNames] = useState([]); //  Channel names
  const [data, setData] = useState([]);
  const [socket, setSocket] = useState(null); // Socket connection for real-time data
  const [socketData, setSocketData] = useState(null);
  const [isPath, setIsPath] = useState('Overview');
  const [tabNames, setTabNames] = useState([
    'Overview',
    'Grid View',
    'Live Data',
    '24 Hours',
    // "Historic Data",
  ]); // All The Tab Names
  const [openNewPage, setOpenNewPage] = useState(false); // For Opening and Closing of Update View Page
  const [images, setImages] = useState([]); // To store saved images
  const [tempImagePosition, setTempImagePosition] = useState([]);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [tabIndexImages, setTabIndexImages] = useState({}); // Store images as per tab index
  const [tabIndexDevices, setTabIndexDevices] = useState({}); // Store indicators as per tab index
  const [tabIndexDisplay, setTabIndexDisplay] = useState({}); // Store display as per tab index
  const [tabIndexController, setTabIndexController] = useState({}); // Store controller as per tab index
  const [tabIndexIO, setTabIndexIO] = useState({}); // Store digital IO as per tab index
  const [tabIndexFlowM, setTabIndexFlowM] = useState({}); // Store flow metetr as per tab index
  const [tabIndexEnergyM, setTabIndexEnergyM] = useState({}); // Store energy meter as per tab index
  const [tabIndexMotor, setTabIndexMotor] = useState({}); // Store motor as per tab index
  const [tabIndexText, setTabIndexText] = useState({}); // Store text as per tab index
  const [tabIndexLineChart, setTabIndexLineChart] = useState({}); // Store Line chart as per tab index
  const [tabIndexPieChart, setTabIndexPieChart] = useState({}); // Store Pie chart as per tab index
  const [tabIndexBarChart, setTabIndexBarChart] = useState({}); // Store Bar chart as per tab index
  const [tabIndexHistogram, setTabIndexHistogram] = useState({}); // Store Histogram as per tab index
  const [tabIndexGauge, setTabIndexGauge] = useState({}); // Store Gauge as per tab index
  const [tabIndexProgress, setTabIndexProgress] = useState({}); // Store Progressbar as per tab index
  const [tabIndexGrid, setTabIndexGrid] = useState({}); // Store Grid view as per tab index
  const [tabIndexTable, setTabIndexTable] = useState({}); // Store Table as per tab index
  const [tabIndexCircularProgress, setTabIndexCircularProgress] = useState({}); // Store CircularProgress as per tab index
  const [tabIndexLines, setTabIndexLines] = useState({});
  const [tabIndexDoughnut, setTabIndexDoughnut] = useState({});
  const [tabIndexSquare, setTabIndexSquare] = useState({});
  const [tabIndexCircle, setTabIndexCircle] = useState({});
  const [tabIndexPolygone, setTabIndexPolygone] = useState({});
  const [tabIndexPipe, setTabIndexPipe] = useState({});
  const [tabIndexSwitch, setTabIndexSwitch] = useState({});
  const [tabIndexCheckbox, setTabIndexCheckbox] = useState({});
  const [tabIndexRadio, setTabIndexRadio] = useState({});
  const [tabIndexSlider, setTabIndexSlider] = useState({});
  const [tabIndexLamp, setTabIndexLamp] = useState({});
  const [tabIndexPush, setTabIndexPush] = useState({});
  const [tabIndexList, setTabIndexList] = useState({});
  const [tabIndexLink, setTabIndexLink] = useState({});
  const [tabIndexClock, setTabIndexClock] = useState({});

  const [tabIndexOverviewInfo, setTabIndexOverviewInfo] = useState({}); // Store info component of overview
  const [tempTabIndexOverviewInfo, setTempTabIndexOverviewInfo] = useState({});
  const [tabIndexOverviewGraph, setTabIndexOverviewGraph] = useState({}); // Store graph component of overview
  const [tempTabIndexOverviewGraph, setTempTabIndexOverviewGraph] = useState(
    {},
  );
  const [tabIndexLiveDataGraph, setTabIndexLiveDataGraph] = useState({}); // Store graph component of live data
  const [tempTabIndexLiveDataGraph, setTempTabIndexLiveDataGraph] = useState(
    {},
  );
  const [tabIndexLastDayTable, setTabIndexLastDayTable] = useState({}); //Store table of 24hour tab
  const [tempTabIndexLastDayTable, setTempTabIndexLastDayTable] = useState({});
  const [tabIndexLastDayGraph, setTabIndexLastDayGraph] = useState({}); //Store graph of 24hour tab
  const [tempTabIndexLastDayGraph, setTempTabIndexLastDayGraph] = useState({});
  const [tabIndexDefaultGrid, setTabIndexDefaultGrid] = useState({}); //Store grid of grid view tab
  const [tempTabIndexDefaultGrid, setTempTabIndexDefaultGrid] = useState({});

  const [headerNames, setHeaderNames] = useState([]);
  const [chartDataLive, setChartDataLive] = useState({
    labels: [],
    datasets: [],
  }); // store live data to display in  line chart

  const [barChartData, setBarChartData] = useState({
    labels: [],
    datasets: [],
  }); // store live data to display in bar chart

  const [histogramData, setHistogramData] = useState({
    labels: [],
    datasets: [],
  }); // store live data to display in bar chart

  const [isMobile, setIsMobile] = useState(false); // To check window size of mobile
  const [screenWidth, setScreenWidth] = useState();
  const [screenHeight, setScreenHeight] = useState();
  const [windowWidth, setWindowWidth] = useState();
  const [windowHeight, setWindowHeight] = useState();
  const [oneDayDataTs, setOneDayDataTS] = useState([]); // Store data of last 24hour
  const [scaleValue, setScaleValue] = useState(1); // To zoom in/out in mobile view
  const [documentId, setDocumentId] = useState('');
  const [vNetPassword, setVNetPassword] = useState(''); // store V-Net password
  const [vNetUsername, setVNetUsername] = useState(''); // store V-Net username
  const [deviceGroupName, setDeviceGroupName] = useState(''); // store V-Net groupname
  const [deviceName, setDeviceName] = useState('');
  const [tagGroupName, setTagGroupName] = useState('');
  const [allChannelGroups, setAllChannelGroups] = useState([]);

  const [containerDimensions, setBuilderSize] = useState({
    width: null,
    height: null,
  });
  const [loginSid, setLoginSid] = useState('');
  const [isChangeSV, setIsChangeSV] = useState(false);
  const [currentDevice, setCurrentDevice] = useState('');
  const [isChannelUpdateModal, setIsChannelUpdateModal] = useState(false);
  const [selectedWidgetChannel, setSelectedWidgetChannel] = useState('');
  const [updateValue, setUpdateValue] = useState('');
  // const []

  const dispatch = useDispatch();
  const toast = useToast();
  const graphData = useSelector((state) => state.viewData.graphData);
  const tagGroupsArr = useSelector((state) => state.tagGroup.tagGroupsArr);
  const responsewidgetData = useSelector((state) => state.viewData.widgetData);
  const vNetSid = useSelector((state) => state.vNet.sid);
  const tagMap = useSelector((state) => state.vNet.tagMap);

  const updateWidgetMsg = useSelector(
    (state) => state.viewData.updateWidgetMsg,
  );

const projectData = useSelector(
  (state) => state.projectData.projectData
);

const currentProject = projectData?.find(
  (project) => project?.uniqueProjectId === uniqueProjectId
);

const projectName = currentProject?.projectName || "";

// console.log(currentProject, 'currentProject in ProjectData.jsx', projectName);
  const [widgetData, setWidgetData] = useState({});

  const [apiChannels, setApiChannels] = useState([]);

  const cuid = '854234a5028f46628cfbc5e135c2b23b';

  function formatFromSeconds(sec) {
    const d = Math.floor(sec / 86400);
    const h = Math.floor((sec % 86400) / 3600);
    const m = Math.floor((sec % 3600) / 60);

    return `${d}d ${h}h ${m}m`;
  }

// console.log(currentDevice, 'currentDevice in ProjectData.jsx', currentDevice);

  useEffect(() => {
    setWidgetData(responsewidgetData);
  }, [responsewidgetData]);

  const layerRef = useRef(null);
  const lineRefs = useRef([]); // keep refs for multiple pipes

  const containerRef = useRef(null);

  useEffect(() => {
    const layer = layerRef.current;

    const anim = new Konva.Animation((frame) => {
      const dashSpeed = 100; // px per second
      lineRefs.current.forEach((line) => {
        if (line) {
          line.dashOffset(-(frame.time * dashSpeed) / 1000);
        }
      });
    }, layer);

    anim.start();

    return () => anim.stop();
  }, []);

  const fetchChannels = async () => {
    try {
      // const response = await fetch(
      //   `${proxy}/api/projectChannelList?projectId=${uniqueProjectId}`,
      // );
      const token = localStorage.getItem('token');
      const response = await fetch(
        `${proxy}/api/projectChannelList?projectId=${uniqueProjectId}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const result = await response.json();

      if (result) {
        setApiChannels(result.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (uniqueProjectId) {
      fetchChannels();
    }
  }, [uniqueProjectId]);

  // Checking mobile view or not
  useEffect(() => {
    setWindowWidth(window.innerWidth);
    setWindowHeight(window.innerHeight);

    if (window.innerWidth < 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, []);

  // Calling API's
  useEffect(() => {
    const token = localStorage.getItem('token');
    const email = localStorage.getItem('organizationEmail');
    const data = {
      ProjectID: uniqueProjectId,
      token: token,
    };
    try {
      dispatch(getProjectSetting(data));
      dispatch(getMqttCredentials(email));
      dispatch(fetchTagGroups(uniqueProjectId));
    } catch (error) {
      console.log(error);
    }
  }, [uniqueProjectId]);

  useEffect(() => {
    setAllChannelGroups(tagGroupsArr);
  }, [tagGroupsArr]);

  //Storing saved V-net info in states
  useEffect(() => {
    if (widgetData?.username) {
      setVNetUsername(widgetData?.username);
    }
    if (widgetData?.password) {
      setVNetPassword(widgetData?.password);
    }
    if (widgetData?.deviceGroupName) {
      setDeviceGroupName(widgetData?.deviceGroupName);
    }
    if (widgetData?.deviceName) {
      setDeviceName(widgetData?.deviceName);
    }
    if (widgetData?.tagGroupName) {
      setTagGroupName(widgetData?.tagGroupName);
    }
  }, [widgetData]);

  const navigate = useNavigate();

  // Function to generate random color
  const getRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  React.useLayoutEffect(() => {
    document.title = 'Project Data';
    if (localStorage.getItem('token') == null) {
      //condition if not logged in
      navigate('/auth/login');
    } // eslint-disable-next-line
  }, []);

  // To Open Update View Page
  const handleNewPage = () => {
    setOpenNewPage(true);
  };

  // Storing current tab index in state
  const handleTabIndex = (tabIndex, tabName) => {
    setSelectedTabIndex(tabIndex);
    setIsPath(tabName);
  };

  // Function to increase scale value
  const increaseScale = () => {
    setScaleValue(scaleValue + 0.1);
  };

  // Function to decrease scale value
  const decreaseScale = () => {
    if (scaleValue > 0.2) {
      setScaleValue(scaleValue - 0.1);
    }
  };

  const handleLinkClick = (e, url) => {
    e.preventDefault();
    window.open(url, '_blank', 'width=700,height=500,noopener,noreferrer');
  };

  // Fetching Updated View Data
  useEffect(() => {
    const apiBody = {
      projectID: uniqueProjectId,
    };
    try {
      dispatch(getWidgetData(apiBody));
    } catch (error) {
      console.log(error);
    }
  }, [openNewPage]);

  // Arraging widget to display it according the saved informations
  useEffect(() => {
    if (Object.keys(widgetData).length > 0) {
      const tempWidgetData = { ...widgetData };

      if (tempWidgetData.data && tempWidgetData.data[0]) {
        setScreenHeight(tempWidgetData.data[0].screenHeight);
        setScreenWidth(tempWidgetData.data[0].screenWidth);
        setBuilderSize(tempWidgetData.data[0].containerDimensions);
        setDocumentId(tempWidgetData.data[0].id);
      }

      if (
        tempWidgetData.data &&
        tempWidgetData.data[0] &&
        tempWidgetData.data[0].tabs
      ) {
        setTabNames(tempWidgetData.data[0].tabs);
      } else {
        setTabNames([
          'Overview',
          'Grid View',
          'Live Data',
          '24 Hours',
          // "Historic Data",
        ]);
      }
      if (
        tempWidgetData.data &&
        tempWidgetData.data[0] &&
        tempWidgetData.data[0].widget
      ) {
        setImages(tempWidgetData.data[0].widget.map((data) => data));
        const organizedImages = {};
        const organizedDevices = {};
        const organizedDisplay = {};
        const organizedController = {};
        const organizedIO = {};
        const organizedFlowMeter = {};
        const organizedEnergyMeter = {};
        const organizedMotor = {};
        const organizedText = {};
        const organizedLineChart = {};
        const organizedPieChart = {};
        const organizedBarChart = {};
        const organizedHistogram = {};
        const organizedGauge = {};
        const organizedProgressBar = {};
        const organizedGrid = {};
        const organizedTable = {};
        const organizedOverviewInfo = {};
        const organizedOverviewGraph = {};
        const organizedLiveDataGraph = {};
        const organizedLastDayTable = {};
        const organizedLastDayGraph = {};
        const organizedDefaultGrid = {};
        const organizedCircularProgress = {};
        const organizedDoughnut = {};
        const organizedLines = {};
        const organizedSquare = {};
        const organizedCircle = {};
        const organizedPolygone = {};
        const organizedPipe = {};
        const organizedSwitch = {};
        const organizedCheckbox = {};
        const organizedRadio = {};
        const organizedSlider = {};
        const organizedLamp = {};
        const organizedPush = {};
        const organizedLink = {};
        const organizedClock = {};

        widgetData.data[0]?.widget.forEach((image) => {
          const {
            x,
            y,
            width,
            height,
            name,
            tabIndex,
            id,
            channelName,
            deviceType,
            unit,
            unitPv,
            unitSv,
            unitSv2,
            unitSv3,
            hideChannel,
            hideValue,
            conditionValue,
            moveValue,
            horizontalMoveChannel,
            verticalMoveChannel,
            zIndex,
          } = image;
          if (name && name.toLowerCase().includes('image')) {
            if (!organizedImages[tabIndex]) {
              organizedImages[tabIndex] = [];
            }
            organizedImages[tabIndex].push({
              x,
              y,
              deviceType,
              width,
              height,
              name,
              tabIndex,
              id,
              zIndex,
              hideChannel,
              hideValue,
              conditionValue,
              moveValue,
              horizontalMoveChannel,
              verticalMoveChannel,
            });
          }

          if (deviceType === 'Controller') {
            if (!organizedController[tabIndex]) {
              organizedController[tabIndex] = [];
            }
            organizedController[tabIndex].push({
              x,
              y,
              name,
              channelName,
              tabIndex,
              id,
              deviceType,
              unit,
              zIndex,
            });
          }
          if (deviceType === 'Indicator') {
            const { name, x, y, tabIndex, channelName, id, deviceType } = image;
            if (!organizedDevices[tabIndex]) {
              organizedDevices[tabIndex] = [];
            }
            organizedDevices[tabIndex].push({
              x,
              y,
              name,
              channelName,
              tabIndex,
              id,
              deviceType,
              unit,
              zIndex,
            });
          }
          if (deviceType === 'Display') {
            const {
              name,
              x,
              y,
              tabIndex,
              channelName,
              id,
              deviceType,
              width,
              height,
              bgColor,
              textColor,
              fontSize,
              hideChannel,
              hideValue,
              zIndex,
            } = image;
            if (!organizedDisplay[tabIndex]) {
              organizedDisplay[tabIndex] = [];
            }
            organizedDisplay[tabIndex].push({
              x,
              y,
              name,
              channelName,
              tabIndex,
              id,
              deviceType,
              width,
              height,
              bgColor,
              textColor,
              fontSize,
              hideChannel,
              hideValue,
              zIndex,
            });
          }

          if (deviceType === 'DigitalIO') {
            const {
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              width,
              height,
              bgColor,
              onText,
              offText,
              onColor,
              offColor,
              text,
              fontSize,
              channelName,
              textColor,
              hideChannel,
              hideValue,
              conditionValue,
              moveValue,
              horizontalMoveChannel,
              verticalMoveChannel,
              on,
              zIndex,
            } = image;

            if (!organizedIO[tabIndex]) {
              organizedIO[tabIndex] = [];
            }
            organizedIO[tabIndex].push({
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              width,
              height,
              bgColor,
              onText,
              offText,
              onColor,
              offColor,
              text,
              fontSize,
              channelName,
              textColor,
              hideChannel,
              hideValue,
              conditionValue,
              moveValue,
              horizontalMoveChannel,
              verticalMoveChannel,
              on,
              zIndex,
            });
          }

          if (deviceType === 'FlowMeter') {
            const { name, x, y, tabIndex, id, deviceType, channelName } = image;

            if (!organizedFlowMeter[tabIndex]) {
              organizedFlowMeter[tabIndex] = [];
            }
            organizedFlowMeter[tabIndex].push({
              x,
              y,
              name,
              channelName,
              tabIndex,
              id,
              deviceType,
              unit,
              unitPv,
              unitSv,
              zIndex,
            });
          }

          if (deviceType === 'EnergyMeter') {
            const { name, x, y, tabIndex, id, deviceType, channelName } = image;

            if (!organizedEnergyMeter[tabIndex]) {
              organizedEnergyMeter[tabIndex] = [];
            }
            organizedEnergyMeter[tabIndex].push({
              x,
              y,
              name,
              channelName,
              tabIndex,
              id,
              deviceType,
              unit,
              unitPv,
              unitSv,
              unitSv2,
              unitSv3,
              zIndex,
            });
          }

          if (deviceType === 'Motor') {
            const {
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              width,
              height,
              on,
              channelName,
              hideChannel,
              hideValue,
              zIndex,
            } = image;

            if (!organizedMotor[tabIndex]) {
              organizedMotor[tabIndex] = [];
            }
            organizedMotor[tabIndex].push({
              x,
              y,
              name,
              channelName,
              tabIndex,
              id,
              deviceType,
              width,
              height,
              on,
              hideChannel,
              hideValue,
              zIndex,
            });
          }

          if (deviceType === 'Text') {
            const {
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              width,
              height,
              bgColor,
              textColor,
              fontSize,
              text,
              alignHorizontally,
              alignVertically,
              channelName,
              zIndex,
              hideChannel,
              hideValue,
              conditionValue,
              moveValue,
              horizontalMoveChannel,
              verticalMoveChannel,
              isTransparent,
            } = image;

            if (!organizedText[tabIndex]) {
              organizedText[tabIndex] = [];
            }
            organizedText[tabIndex].push({
              x,
              y,
              name,
              tabIndex,
              id,
              deviceType,
              width,
              height,
              bgColor,
              textColor,
              fontSize,
              text,
              alignHorizontally,
              alignVertically,
              channelName,
              zIndex,
              hideChannel,
              hideValue,
              conditionValue,
              moveValue,
              horizontalMoveChannel,
              verticalMoveChannel,
              isTransparent,
            });
          }

          if (deviceType === 'LineChart') {
            const {
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              chartChannel,
              width,
              height,
              hour,
              minute,
              zIndex,
              lineStyle,
              isCurveLine,
              isSteppedLine,
              minY,
              maxY,
              xInterval,
              yInterval,
              channelsGroup,
            } = image;
            if (!organizedLineChart[tabIndex]) {
              organizedLineChart[tabIndex] = [];
            }
            organizedLineChart[tabIndex].push({
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              chartChannel,
              width,
              height,
              hour,
              minute,
              channelsGroup,
              zIndex,
              lineStyle,
              isCurveLine,
              isSteppedLine,
              minY,
              maxY,
              xInterval,
              yInterval,
            });
          }

          if (deviceType === 'PieChart') {
            const {
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              chartChannel,
              width,
              height,
              zIndex,
              channelsGroup,
            } = image;
            if (!organizedPieChart[tabIndex]) {
              organizedPieChart[tabIndex] = [];
            }
            organizedPieChart[tabIndex].push({
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              chartChannel,
              width,
              height,
              zIndex,
              channelsGroup,
            });
          }
          if (deviceType === 'BarChart') {
            const {
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              chartChannel,
              width,
              height,
              zIndex,
              channelsGroup,
            } = image;
            if (!organizedBarChart[tabIndex]) {
              organizedBarChart[tabIndex] = [];
            }
            organizedBarChart[tabIndex].push({
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              chartChannel,
              width,
              height,
              zIndex,
              channelsGroup,
            });
          }

          if (deviceType === 'Histogram') {
            const {
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              chartChannel,
              width,
              height,
              hour,
              minute,
              zIndex,
              channelsGroup,
            } = image;
            if (!organizedHistogram[tabIndex]) {
              organizedHistogram[tabIndex] = [];
            }
            organizedHistogram[tabIndex].push({
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              chartChannel,
              width,
              height,
              hour,
              minute,
              zIndex,
              channelsGroup,
            });
          }

          if (deviceType === 'Gauge') {
            const {
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              chartChannel,
              minVal,
              maxVal,
              width,
              height,
              fontSize,
              bgColor,
              textColor,
              zIndex,
            } = image;
            if (!organizedGauge[tabIndex]) {
              organizedGauge[tabIndex] = [];
            }
            organizedGauge[tabIndex].push({
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              chartChannel,
              minVal,
              maxVal,
              width,
              height,
              fontSize,
              zIndex,
            });
          }

          if (deviceType === 'ProgressBar') {
            const {
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              chartChannel,
              minVal,
              maxVal,
              rotate,
              width,
              height,
              fontSize,
              bgColor,
              zIndex,
            } = image;
            if (!organizedProgressBar[tabIndex]) {
              organizedProgressBar[tabIndex] = [];
            }
            organizedProgressBar[tabIndex].push({
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              chartChannel,
              minVal,
              maxVal,
              rotate,
              width,
              height,
              fontSize,
              bgColor,
              zIndex,
            });
          }

          if (deviceType === 'Grid') {
            const {
              name,
              deviceType,
              tabIndex,
              chartChannel,
              id,
              x,
              y,
              width,
              height,
              zIndex,
            } = image;
            if (!organizedGrid[tabIndex]) {
              organizedGrid[tabIndex] = [];
            }
            organizedGrid[tabIndex].push({
              name,
              tabIndex,
              id,
              deviceType,
              chartChannel,
              x,
              y,
              width,
              height,
              zIndex,
            });
          }

          if (deviceType === 'Table') {
            const {
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              width,
              height,
              chartChannel,
              column,
              zIndex,
            } = image;
            if (!organizedTable[tabIndex]) {
              organizedTable[tabIndex] = [];
            }
            organizedTable[tabIndex].push({
              name,
              tabIndex,
              id,
              deviceType,
              x,
              y,
              width,
              height,
              chartChannel,
              column,
              zIndex,
            });
          }

          if (deviceType === 'CircularProgress') {
            const {
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              width,
              height,
              chartChannel,
              maxVal,
              zIndex,
            } = image;
            if (!organizedCircularProgress[tabIndex]) {
              organizedCircularProgress[tabIndex] = [];
            }
            organizedCircularProgress[tabIndex].push({
              name,
              tabIndex,
              id,
              deviceType,
              x,
              y,
              width,
              height,
              chartChannel,
              maxVal,
              zIndex,
            });
          }

          if (deviceType === 'Doughnut') {
            const {
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              chartChannel,
              width,
              height,
              zIndex,
            } = image;
            if (!organizedDoughnut[tabIndex]) {
              organizedDoughnut[tabIndex] = [];
            }
            organizedDoughnut[tabIndex].push({
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              chartChannel,
              width,
              height,
              zIndex,
            });
          }

          if (deviceType === 'Line') {
            const {
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              width,
              height,
              length,
              deltaX,
              deltaY,
              angle,
              hideValue,
              hideChannel,
              bgColor,
              conditionValue,
              moveValue,
              horizontalMoveChannel,
              verticalMoveChannel,
            } = image;
            if (!organizedLines[tabIndex]) {
              organizedLines[tabIndex] = [];
            }
            organizedLines[tabIndex].push({
              name,
              tabIndex,
              id,
              deviceType,
              x,
              y,
              width,
              height,
              length,
              deltaX,
              deltaY,
              angle,
              zIndex,
              hideValue,
              hideChannel,
              bgColor,
              conditionValue,
              moveValue,
              horizontalMoveChannel,
              verticalMoveChannel,
            });
          }

          if (deviceType === 'Square') {
            const {
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              width,
              height,
              bgColor,
              onText,
              offText,
              onColor,
              offColor,
              text,
              fontSize,
              channelName,
              textColor,
              hideChannel,
              hideValue,
              conditionValue,
              moveValue,
              horizontalMoveChannel,
              verticalMoveChannel,
              zIndex,
            } = image;
            if (!organizedSquare[tabIndex]) {
              organizedSquare[tabIndex] = [];
            }
            organizedSquare[tabIndex].push({
              name,
              tabIndex,
              id,
              deviceType,
              x,
              y,
              width,
              height,
              bgColor,
              onText,
              offText,
              onColor,
              offColor,
              text,
              fontSize,
              channelName,
              textColor,
              hideChannel,
              hideValue,
              conditionValue,
              moveValue,
              horizontalMoveChannel,
              verticalMoveChannel,
              zIndex,
            });
          }

          if (deviceType === 'Circle') {
            const {
              name,
              tabIndex,
              id,
              deviceType,
              x,
              y,
              width,
              height,
              bgColor,
              onText,
              offText,
              onColor,
              offColor,
              text,
              fontSize,
              channelName,
              textColor,
              hideChannel,
              hideValue,
              conditionValue,
              moveValue,
              horizontalMoveChannel,
              verticalMoveChannel,
              zIndex,
            } = image;
            if (!organizedCircle[tabIndex]) {
              organizedCircle[tabIndex] = [];
            }
            organizedCircle[tabIndex].push({
              name,
              tabIndex,
              id,
              deviceType,
              x,
              y,
              width,
              height,
              bgColor,
              onText,
              offText,
              onColor,
              offColor,
              text,
              fontSize,
              channelName,
              textColor,
              hideChannel,
              hideValue,
              conditionValue,
              moveValue,
              horizontalMoveChannel,
              verticalMoveChannel,
              zIndex,
            });
          }

          if (deviceType === 'Polygone') {
            const {
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              width,
              height,
              bgColor,
              points,
              hideChannel,
              hideValue,
              zIndex,
            } = image;
            if (!organizedPolygone[tabIndex]) {
              organizedPolygone[tabIndex] = [];
            }
            organizedPolygone[tabIndex].push({
              name,
              tabIndex,
              id,
              deviceType,
              x,
              y,
              width,
              height,
              bgColor,
              points,
              hideChannel,
              hideValue,
              zIndex,
            });
          }

          if (deviceType === 'Pipe') {
            const {
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              width,
              height,
              bgColor,
              points,
              hideChannel,
              hideValue,
              channelName,
              zIndex,
            } = image;
            if (!organizedPipe[tabIndex]) {
              organizedPipe[tabIndex] = [];
            }
            organizedPipe[tabIndex].push({
              name,
              tabIndex,
              id,
              deviceType,
              x,
              y,
              width,
              height,
              bgColor,
              points,
              hideChannel,
              hideValue,
              channelName,
              zIndex,
            });
          }

          if (deviceType === 'Switch') {
            const {
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              on,
              chartChannel,
              bgColor,
            } = image;

            if (!organizedSwitch[tabIndex]) {
              organizedSwitch[tabIndex] = [];
            }
            organizedSwitch[tabIndex].push({
              x,
              y,
              name,
              on,
              tabIndex,
              id,
              deviceType,
              chartChannel,
              hideChannel,
              hideValue,
              bgColor,
              zIndex,
            });
          }

          if (deviceType === 'Checkbox') {
            const { name, x, y, tabIndex, id, deviceType, width, height, on } =
              image;

            if (!organizedCheckbox[tabIndex]) {
              organizedCheckbox[tabIndex] = [];
            }
            organizedCheckbox[tabIndex].push({
              x,
              y,
              name,
              tabIndex,
              id,
              deviceType,
              width,
              height,
              on,
              hideChannel,
              hideValue,
              zIndex,
            });
          }

          if (deviceType === 'Radio') {
            const {
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              width,
              height,
              points,
              selectedIndex,
              hideChannel,
              hideValue,
            } = image;

            if (!organizedRadio[tabIndex]) {
              organizedRadio[tabIndex] = [];
            }
            organizedRadio[tabIndex].push({
              x,
              y,
              name,
              tabIndex,
              id,
              deviceType,
              width,
              height,
              points,
              selectedIndex,
              hideChannel,
              hideValue,
              zIndex,
            });
          }

          if (deviceType === 'Slider') {
            const {
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              chartChannel,
              minVal,
              maxVal,
              width,
              height,
              hideChannel,
              hideValue,
              bgColor,
              fontSize,
              textColor,
              zIndex,
            } = image;
            if (!organizedSlider[tabIndex]) {
              organizedSlider[tabIndex] = [];
            }
            organizedSlider[tabIndex].push({
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              chartChannel,
              minVal,
              maxVal,
              width,
              height,
              hideChannel,
              hideValue,
              bgColor,
              fontSize,
              textColor,
              zIndex,
            });
          }

          if (deviceType === 'Lamp') {
            const {
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              chartChannel,
              width,
              height,
              hideChannel,
              hideValue,
              zIndex,
            } = image;

            if (!organizedLamp[tabIndex]) {
              organizedLamp[tabIndex] = [];
            }

            organizedLamp[tabIndex].push({
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              chartChannel,
              hideChannel,
              hideValue,
              width,
              height,
              zIndex,
            });
          }

          if (deviceType === 'Push') {
            const {
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              width,
              height,
              bgColor,
              hideChannel,
              hideValue,
              zIndex,
            } = image;
            if (!organizedPush[tabIndex]) {
              organizedPush[tabIndex] = [];
            }
            organizedPush[tabIndex].push({
              name,
              tabIndex,
              id,
              deviceType,
              x,
              y,
              width,
              height,
              bgColor,
              hideChannel,
              hideValue,
              zIndex,
            });
          }

          if (deviceType === 'Link') {
            const {
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              width,
              height,
              bgColor,
              textColor,
              fontSize,
              text,
              alignHorizontally,
              alignVertically,
              hideChannel,
              hideValue,
              zIndex,
            } = image;
            if (!organizedLink[tabIndex]) {
              organizedLink[tabIndex] = [];
            }
            organizedLink[tabIndex].push({
              x,
              y,
              name,
              tabIndex,
              id,
              deviceType,
              width,
              height,
              bgColor,
              textColor,
              fontSize,
              text,
              alignHorizontally,
              alignVertically,
              hideChannel,
              hideValue,
              zIndex,
            });
          }

          if (deviceType === 'Push') {
            const {
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              width,
              height,
              bgColor,
              zIndex,
            } = image;
            if (!organizedPush[tabIndex]) {
              organizedPush[tabIndex] = [];
            }
            organizedPush[tabIndex].push({
              name,
              tabIndex,
              id,
              deviceType,
              x,
              y,
              width,
              height,
              bgColor,
              zIndex,
            });
          }

          if (deviceType === 'Clock') {
            const {
              name,
              x,
              y,
              tabIndex,
              id,
              deviceType,
              width,
              height,
              hideChannel,
              hideValue,
              zIndex,
            } = image;
            if (!organizedClock[tabIndex]) {
              organizedClock[tabIndex] = [];
            }
            organizedClock[tabIndex].push({
              name,
              tabIndex,
              id,
              deviceType,
              x,
              y,
              width,
              height,
              hideChannel,
              hideValue,
              zIndex,
            });
          }

          if (name === 'overviewInfo') {
            const { name, tabIndex, x, y, id, width, height } = image;
            if (!organizedOverviewInfo[tabIndex]) {
              organizedOverviewInfo[tabIndex] = [];
            }
            organizedOverviewInfo[tabIndex].push({
              name,
              id,
              x,
              y,
              width,
              height,
              tabIndex,
            });
            setTempTabIndexOverviewInfo(organizedOverviewInfo);
            setTabIndexOverviewInfo(organizedOverviewInfo);
          }

          if (name === 'overviewGraph') {
            const { name, tabIndex, x, y, id, width, height } = image;
            if (!organizedOverviewGraph[tabIndex]) {
              organizedOverviewGraph[tabIndex] = [];
            }
            organizedOverviewGraph[tabIndex].push({
              name,
              id,
              x,
              y,
              width,
              height,
              tabIndex,
            });
            setTempTabIndexOverviewGraph(organizedOverviewGraph);
            setTabIndexOverviewGraph(organizedOverviewGraph);
          }

          if (name === 'liveDataGraph') {
            const { name, tabIndex, x, y, id, width, height } = image;
            if (!organizedLiveDataGraph[tabIndex]) {
              organizedLiveDataGraph[tabIndex] = [];
            }
            organizedLiveDataGraph[tabIndex].push({
              name,
              id,
              x,
              y,
              width,
              height,
              tabIndex,
            });

            setTabIndexLiveDataGraph(organizedLiveDataGraph);
            setTempTabIndexLiveDataGraph(organizedLiveDataGraph);
          }

          if (name === 'lastDayTable') {
            const { name, tabIndex, x, y, id } = image;
            if (!organizedLastDayTable[tabIndex]) {
              organizedLastDayTable[tabIndex] = [];
            }
            organizedLastDayTable[tabIndex].push({
              name,
              id,
              x,
              y,
              width,
              height,
              tabIndex,
            });
            setTabIndexLastDayTable(organizedLastDayTable);
            setTempTabIndexLastDayTable(organizedLastDayTable);
          }

          if (name === 'lastDayGraph') {
            const { name, tabIndex, x, y, id } = image;
            if (!organizedLastDayGraph[tabIndex]) {
              organizedLastDayGraph[tabIndex] = [];
            }
            organizedLastDayGraph[tabIndex].push({
              name,
              id,
              x,
              y,
              width,
              height,
              tabIndex,
            });
            setTabIndexLastDayGraph(organizedLastDayGraph);
            setTempTabIndexLastDayGraph(organizedLastDayGraph);
          }

          if (name === 'DefaultGrid') {
            const { name, tabIndex, x, y, id, width, height } = image;
            if (!organizedDefaultGrid[tabIndex]) {
              organizedDefaultGrid[tabIndex] = [];
            }
            organizedDefaultGrid[tabIndex].push({
              name,
              id,
              x,
              y,
              width,
              height,
              tabIndex,
            });
            setTempTabIndexDefaultGrid(organizedDefaultGrid);
            setTabIndexDefaultGrid(organizedDefaultGrid);
          }
        });

        setTabIndexLineChart(organizedLineChart);
        setTabIndexText(organizedText);
        setTabIndexMotor(organizedMotor);
        setTabIndexEnergyM(organizedEnergyMeter);
        setTabIndexFlowM(organizedFlowMeter);
        setTabIndexIO(organizedIO);
        setTabIndexDevices(organizedDevices);
        setTabIndexDisplay(organizedDisplay);
        setTabIndexController(organizedController);
        setTabIndexImages(organizedImages);
        setTabIndexClock(organizedClock);
        setTabIndexPush(organizedPush);
        setTabIndexLink(organizedLink);
        setTabIndexLamp(organizedLamp);
        setTabIndexSlider(organizedSlider);
        setTabIndexRadio(organizedRadio);
        setTabIndexSwitch(organizedSwitch);
        setTabIndexPipe(organizedPipe);
        setTabIndexPolygone(organizedPolygone);
        setTabIndexCircle(organizedCircle);
        setTabIndexSquare(organizedSquare);
        setTabIndexLines(organizedLines);
        setTabIndexDoughnut(organizedDoughnut);
        setTabIndexCircularProgress(organizedCircularProgress);
        setTabIndexGauge(organizedGauge);
        setTabIndexHistogram(organizedHistogram);
        setTabIndexBarChart(organizedBarChart);
        setTabIndexPieChart(organizedPieChart);
        setTabIndexTable(organizedTable);
        setTabIndexGrid(organizedGrid);
        setTabIndexProgress(organizedProgressBar);
        setTabIndexCheckbox(organizedCheckbox);
      }
    }
  }, [widgetData]);

  const shouldBlinkWidget = (channelValue, blinkValue, blinkFunction) => {
    if (
      channelValue === undefined ||
      blinkValue === undefined ||
      !blinkFunction
    )
      return false;

    const val = Number(channelValue);
    const blinkVal = Number(blinkValue);
    switch (blinkFunction) {
      case '=':
        return val === blinkVal;
      case '>':
        return val > blinkVal;
      case '<':
        return val < blinkVal;
      default:
        return false;
    }
  };

  // Function to generate saved IMAGES according saved information

  const generateImage = () => {
    const selectedTabImages = tabIndexImages[selectedTabIndex];

    if (Array.isArray(selectedTabImages)) {
      return tabIndexImages[selectedTabIndex].map((image, index) => {
        const {
          x,
          y,
          width,
          height,
          name,
          hideChannel,
          hideValue,
          conditionValue,
          moveValue,
          horizontalMoveChannel,
          verticalMoveChannel,
          zIndex,
          blinkChannel,
          blinkValue,
          blinkFunction,
          blinkFrequency,
        } = image;

        //     HIDE LOGIC

        const horizontalChannelData = tableData.find(
          (d) => d.Header === horizontalMoveChannel,
        );

        const verticalChannelData = tableData.find(
          (d) => d.Header === verticalMoveChannel,
        );

        const blinkChannelData = tableData.find(
          (d) => d.Header === blinkChannel,
        );

        const hideChannelData = tableData.find((d) => d.Header === hideChannel);

        let isHide = false;
        if (hideChannelData && hideValue !== undefined) {
          isHide = hideChannelData.val.toString() === hideValue.toString();
        }

        // HORIZONTAL MOVEMENT

        let leftPosition = x ? parseFloat(x) : 0;

        if (
          horizontalChannelData &&
          conditionValue &&
          moveValue &&
          conditionValue.toLeft !== undefined &&
          conditionValue.toRight !== undefined &&
          moveValue.toLeft !== undefined &&
          moveValue.toRight !== undefined
        ) {
          const currentVal = Number(horizontalChannelData.val);
          const rangeMin = Number(conditionValue.toLeft);
          const rangeMax = Number(conditionValue.toRight);
          const moveMin = Number(moveValue.toLeft);
          const moveMax = Number(moveValue.toRight);

          if (currentVal >= rangeMin && currentVal <= rangeMax) {
            const ratio = (currentVal - rangeMin) / (rangeMax - rangeMin);

            leftPosition = moveMin + ratio * (moveMax - moveMin);
          }
        }

        let topPosition = y ? parseFloat(y) : 0;

        if (
          verticalChannelData &&
          conditionValue &&
          moveValue &&
          conditionValue.toTop !== undefined &&
          conditionValue.toBottom !== undefined &&
          moveValue.toTop !== undefined &&
          moveValue.toBottom !== undefined
        ) {
          const currentVal = Number(verticalChannelData.val);
          const rangeMin = Number(conditionValue.toTop);
          const rangeMax = Number(conditionValue.toBottom);
          const moveMin = Number(moveValue.toTop);
          const moveMax = Number(moveValue.toBottom);

          if (currentVal >= rangeMin && currentVal <= rangeMax) {
            const ratio = (currentVal - rangeMin) / (rangeMax - rangeMin);

            topPosition = moveMin + ratio * (moveMax - moveMin);
          }
        }

        // -------- BLINK LOGIC ----------
        let shouldBlink = false;
        let blinkSpeed = '1s';

        if (blinkChannelData) {
          shouldBlink = shouldBlinkWidget(
            blinkChannelData.val,
            blinkValue,
            blinkFunction,
          );

          blinkSpeed = blinkFrequency ? `${blinkFrequency / 1000}s` : '1s';
        }

        const imageStyle = {
          display: isHide ? 'none' : 'flex',
          position: 'absolute',
          top: `${topPosition}px`,
          left: `${leftPosition}px`,
          width,
          height,
          scale: isMobile ? scaleValue.toString() : '1',
          zIndex: zIndex ?? '1',
          animationDuration: shouldBlink ? blinkSpeed : '0s',
        };

        return (
          <div style={imageStyle} key={index}>
            <img src={name} alt={`WidgetImage-${index}`} />
          </div>
        );
      });
    }
  };

  // Function to generate saved INDICATORS according saved information

  const generateDevice = () => {
    const selectedTabDevices = tabIndexDevices[selectedTabIndex];
    if (Array.isArray(selectedTabDevices)) {
      return selectedTabDevices.map((device, index) => {
        const {
          x,
          y,
          name,
          id,
          channelName,
          tabIndex,
          deviceType,
          unit,
          zIndex,
        } = device;

        const deviceStyle = {
          backgroundColor: 'rgb(20, 17, 15)',
          width: isMobile ? '55%' : '20%',
          position: 'absolute',
          top: y + 'px',
          left: x + 'px',
          borderRadius: '0.625rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5rem',
          padding: '0.6rem',
          scale: isMobile ? scaleValue.toString() : '1',
          zIndex: zIndex ? zIndex : '1',
        };

        return (
          <>
            <div style={deviceStyle} key={index}>
              <Devices
                openNewPage={openNewPage}
                tabIndexDevices={tabIndexDevices}
                device={device}
                name={name}
                tableData={tableData}
                channelName={channelName.PV}
                tabIndex={tabIndex}
                id={id}
                selectedTabIndex={selectedTabIndex}
                deviceType={deviceType}
                unit={unit}
              />
            </div>
          </>
        );
      });
    }
  };

  // Function to generate saved DISPLAY according saved information

  const generateDisplay = () => {
    const selectedTabDevices = tabIndexDisplay[selectedTabIndex];
    if (Array.isArray(selectedTabDevices)) {
      return selectedTabDevices.map((device, index) => {
        const {
          x,
          y,
          channelName,
          width,
          height,
          bgColor,
          textColor,
          fontSize,
          hideChannel,
          hideValue,
          zIndex,
        } = device;

        const hideChannelData = tableData.find((d) => d.Header === hideChannel);

        let isHide = false;
        if (hideChannelData && hideValue !== undefined) {
          isHide = hideChannelData.val.toString() === hideValue.toString();
        }

        const deviceStyle = {
          display: isHide ? 'none' : '',
          position: 'absolute',
          top: y + 'px',
          left: x + 'px',
          borderRadius: '0.625rem',
          backgroundColor: bgColor,
          color: textColor,
          padding: '0.6rem 1rem',
          fontSize: fontSize ? fontSize + 'px' : '30px',
          width: width ? width : '12%',
          height: height ? height : undefined,
          scale: isMobile ? scaleValue.toString() : '1',
          zIndex: zIndex ? zIndex : '1',
        };

        return (
          <>
            <div style={deviceStyle} key={index}>
              <DeviceDisplay
                openNewPage={openNewPage}
                tableData={tableData}
                channelName={channelName.PV}
              />
            </div>
          </>
        );
      });
    }
  };

  // Function to generate saved CONTROLLERS according saved information
  const generateController = () => {
    const selectedTabDevices = tabIndexController[selectedTabIndex];
    if (Array.isArray(selectedTabDevices)) {
      return selectedTabDevices.map((device, index) => {
        const {
          x,
          y,
          name,
          id,
          channelName,
          tabIndex,
          deviceType,
          unit,
          zIndex,
        } = device;
        const deviceStyle = {
          backgroundColor: 'rgb(20, 17, 15)',
          width: isMobile ? '55%' : '20%',
          position: 'absolute',
          top: y + 'px',
          left: x + 'px',
          borderRadius: '0.625rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5rem',
          padding: '0.6rem',
          scale: isMobile ? scaleValue.toString() : '1',

          zIndex: zIndex ? zIndex : '1',
        };

        return (
          <>
            <div style={deviceStyle} key={index}>
              <DeviceController
                openNewPage={openNewPage}
                tabIndexController={tabIndexController}
                device={device}
                name={name}
                tableData={tableData}
                channelName={channelName}
                tabIndex={tabIndex}
                id={id}
                selectedTabIndex={selectedTabIndex}
                deviceType={deviceType}
                unit={unit}
              />
            </div>
          </>
        );
      });
    }
  };

  // Function to generate saved DIGITAL I/O according saved information
  const generateIO = () => {
    const selectedTabDevices = tabIndexIO[selectedTabIndex];
    if (Array.isArray(selectedTabDevices)) {
      return selectedTabDevices.map((device, index) => {
        const {
          x,
          y,
          name,
          on,
          width,
          height,
          onText,
          offText,
          onColor,
          offColor,
          channelName,
          fontSize,
          zIndex,
          hideChannel,
          hideValue,
          conditionValue,
          moveValue,
          horizontalMoveChannel,
          verticalMoveChannel,
          blinkChannel,
          blinkValue,
          blinkFunction,
          blinkFrequency,
        } = device;

        // HIDE LOGIC

        const hideChannelData = tableData.find((d) => d.Header === hideChannel);

        const horizontalChannelData = tableData.find(
          (d) => d.Header === horizontalMoveChannel,
        );

        const verticalChannelData = tableData.find(
          (d) => d.Header === verticalMoveChannel,
        );

        const blinkChannelData = tableData.find(
          (d) => d.Header === blinkChannel,
        );

        let isHide = false;
        if (hideChannelData && hideValue !== undefined) {
          isHide = hideChannelData.val.toString() === hideValue.toString();
        }

        // HORIZONTAL MOVEMENT

        let leftPosition = x ? parseFloat(x) : 0;

        if (
          horizontalChannelData &&
          conditionValue &&
          moveValue &&
          conditionValue.toLeft !== undefined &&
          conditionValue.toRight !== undefined &&
          moveValue.toLeft !== undefined &&
          moveValue.toRight !== undefined
        ) {
          const currentVal = Number(horizontalChannelData.val);
          const rangeMin = Number(conditionValue.toLeft);
          const rangeMax = Number(conditionValue.toRight);
          const moveMin = Number(moveValue.toLeft);
          const moveMax = Number(moveValue.toRight);

          if (currentVal >= rangeMin && currentVal <= rangeMax) {
            const ratio = (currentVal - rangeMin) / (rangeMax - rangeMin);

            leftPosition = moveMin + ratio * (moveMax - moveMin);
          }
        }

        let topPosition = y ? parseFloat(y) : 0;

        if (
          verticalChannelData &&
          conditionValue &&
          moveValue &&
          conditionValue.toTop !== undefined &&
          conditionValue.toBottom !== undefined &&
          moveValue.toTop !== undefined &&
          moveValue.toBottom !== undefined
        ) {
          const currentVal = Number(verticalChannelData.val);
          const rangeMin = Number(conditionValue.toTop);
          const rangeMax = Number(conditionValue.toBottom);
          const moveMin = Number(moveValue.toTop);
          const moveMax = Number(moveValue.toBottom);

          if (currentVal >= rangeMin && currentVal <= rangeMax) {
            const ratio = (currentVal - rangeMin) / (rangeMax - rangeMin);

            topPosition = moveMin + ratio * (moveMax - moveMin);
          }
        }

        // -------- BLINK LOGIC ----------
        let shouldBlink = false;
        let blinkSpeed = '1s';

        if (blinkChannelData) {
          shouldBlink = shouldBlinkWidget(
            blinkChannelData.val,
            blinkValue,
            blinkFunction,
          );

          blinkSpeed = blinkFrequency ? `${blinkFrequency / 1000}s` : '1s';
        }

        const deviceStyle = {
          width: isMobile ? '57%' : width ? width : '190px',
          height: height ? height : '160px',
          display: isHide ? 'none' : 'flex',

          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '0.5rem',
          position: 'absolute',
          left: `${leftPosition}px`,
          top: `${topPosition}px`,
          scale: isMobile ? scaleValue.toString() : '1',
          zIndex: zIndex ? zIndex : '1',
          animationDuration: shouldBlink ? blinkSpeed : '0s',
        };

        return (
          <>
            <div style={deviceStyle} key={index}>
              <DeviceIO
                name={name}
                on={on}
                onText={onText}
                offText={offText}
                onColor={onColor}
                offColor={offColor}
                tableData={tableData}
                channelName={channelName}
                fontSize={fontSize}
              />
            </div>
          </>
        );
      });
    }
  };

  // Function to generate saved FLOWMETERS according saved information
  const generateFlowMeter = () => {
    const selectedTabDevices = tabIndexFlowM[selectedTabIndex];

    if (Array.isArray(selectedTabDevices)) {
      return selectedTabDevices.map((device, index) => {
        const {
          x,
          y,
          name,
          id,
          channelName,
          tabIndex,
          deviceType,
          unit,
          unitPv,
          unitSv,
          zIndex,
        } = device;

        const deviceStyle = {
          backgroundColor: 'rgb(20, 17, 15)',
          width: isMobile ? '55%' : '25%',
          position: 'absolute',
          top: y + 'px',
          left: x + 'px',
          borderRadius: '0.625rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5rem',
          padding: '0.6rem',
          scale: isMobile ? scaleValue.toString() : '1',
          zIndex: zIndex ? zIndex : '1',
        };

        return (
          <>
            <div style={deviceStyle} key={index}>
              <DeviceFlowMeter
                openNewPage={openNewPage}
                tabIndexFlowM={tabIndexFlowM}
                device={device}
                name={name}
                tableData={tableData}
                channelName={channelName}
                tabIndex={tabIndex}
                id={id}
                selectedTabIndex={selectedTabIndex}
                deviceType={deviceType}
                unit={unit}
                unitPv={unitPv}
                unitSv={unitSv}
              />
            </div>
          </>
        );
      });
    }
  };

  // Function to generate saved ENERGYMETERS according saved information
  const generateEnergyMeter = () => {
    const selectedTabDevices = tabIndexEnergyM[selectedTabIndex];

    if (Array.isArray(selectedTabDevices)) {
      return selectedTabDevices.map((device, index) => {
        const {
          x,
          y,
          name,
          id,
          channelName,
          tabIndex,
          deviceType,
          unit,
          unitPv,
          unitSv,
          unitSv2,
          unitSv3,
          zIndex,
        } = device;
        const deviceStyle = {
          backgroundColor: 'rgb(20, 17, 15)',
          width: isMobile ? '55%' : '25%',
          position: 'absolute',
          top: y + 'px',
          left: x + 'px',
          borderRadius: '0.625rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          padding: '0.6rem',
          scale: isMobile ? scaleValue.toString() : '1',
          zIndex: zIndex ? zIndex : '1',
        };

        return (
          <>
            <div style={deviceStyle} key={index}>
              <DeviceEnergyMeter
                openNewPage={openNewPage}
                tabIndexEnergyM={tabIndexEnergyM}
                device={device}
                name={name}
                tableData={tableData}
                channelName={channelName}
                tabIndex={tabIndex}
                id={id}
                selectedTabIndex={selectedTabIndex}
                deviceType={deviceType}
                unit={unit}
                unitPv={unitPv}
                unitSv={unitSv}
                unitSv2={unitSv2}
                unitSv3={unitSv3}
              />
            </div>
          </>
        );
      });
    }
  };

  // Function to generate saved TEXTS according saved information
  const generateText = () => {
    const selectedTabDevices = tabIndexText[selectedTabIndex];
    if (Array.isArray(selectedTabDevices)) {
      return selectedTabDevices.map((device, index) => {
        const {
          x,
          y,
          id,
          width,
          height,
          bgColor,
          textColor,
          deviceType,
          text,
          fontSize,
          alignHorizontally,
          alignVertically,
          channelName,
          zIndex,
          hideChannel,
          hideValue,
          conditionValue,
          moveValue,
          horizontalMoveChannel,
          verticalMoveChannel,
          isTransparent,
        } = device;

        const channel = tableData.find(
          (data) => data.Header === channelName?.PV,
        );
        const hideChannelData = tableData.find((d) => d.Header === hideChannel);

        const horizontalChannelData = tableData.find(
          (d) => d.Header === horizontalMoveChannel,
        );

        const verticalChannelData = tableData.find(
          (d) => d.Header === verticalMoveChannel,
        );

        let statusVal;

        if (channel) {
          if (channel.Header.includes('Event_')) {
            statusVal = formatFromSeconds(channel?.val);
          } else {
            statusVal = channel?.val;
          }
        } else {
          statusVal = text;
        }

        let isHide = false;
        if (hideChannelData && hideValue !== undefined) {
          isHide = hideChannelData.val.toString() === hideValue.toString();
        }

        // HORIZONTAL MOVEMENT

        let leftPosition = x ? parseFloat(x) : 0;

        if (
          horizontalChannelData &&
          conditionValue &&
          moveValue &&
          conditionValue.toLeft !== undefined &&
          conditionValue.toRight !== undefined &&
          moveValue.toLeft !== undefined &&
          moveValue.toRight !== undefined
        ) {
          const currentVal = Number(horizontalChannelData.val);
          const rangeMin = Number(conditionValue.toLeft);
          const rangeMax = Number(conditionValue.toRight);
          const moveMin = Number(moveValue.toLeft);
          const moveMax = Number(moveValue.toRight);

          if (currentVal >= rangeMin && currentVal <= rangeMax) {
            const ratio = (currentVal - rangeMin) / (rangeMax - rangeMin);

            leftPosition = moveMin + ratio * (moveMax - moveMin);
          }
        }

        let topPosition = y ? parseFloat(y) : 0;

        if (
          verticalChannelData &&
          conditionValue &&
          moveValue &&
          conditionValue.toTop !== undefined &&
          conditionValue.toBottom !== undefined &&
          moveValue.toTop !== undefined &&
          moveValue.toBottom !== undefined
        ) {
          const currentVal = Number(verticalChannelData.val);
          const rangeMin = Number(conditionValue.toTop);
          const rangeMax = Number(conditionValue.toBottom);
          const moveMin = Number(moveValue.toTop);
          const moveMax = Number(moveValue.toBottom);

          if (currentVal >= rangeMin && currentVal <= rangeMax) {
            const ratio = (currentVal - rangeMin) / (rangeMax - rangeMin);

            topPosition = moveMin + ratio * (moveMax - moveMin);
          }
        }

        const deviceStyle = {
          position: 'absolute',
          top: topPosition + 'px',
          left: leftPosition + 'px',
          backgroundColor: isTransparent ? 'transparent' : bgColor,
          color: textColor,
          padding: '0.6rem 1rem',
          fontSize: fontSize ? fontSize + 'px' : '30px',
          width: width ?? 'fit-content',
          height: height ?? 'fit-content',
          scale: isMobile ? scaleValue.toString() : '1',
          display: isHide ? 'none' : 'inline-flex',
          whiteSpace: width || height ? 'normal' : 'nowrap',
          wordBreak: 'break-word',
          justifyContent: alignHorizontally ?? 'flex-start',
          alignItems: alignVertically ?? 'flex-start',
          zIndex: zIndex ?? 1,
        };

        return (
          <>
            <div
              style={deviceStyle}
              key={index}
              onDoubleClick={(e) => setIsChannelUpdateModal(true)}
              onClick={() => {
                setCurrentDevice(device);
                setSelectedWidgetChannel(channelName?.PV || null);
              }}
            >
              {statusVal}
            </div>
          </>
        );
      });
    }
  };

  // Function to generate saved MOTORS according saved information
  const generateMotor = () => {
    const selectedTabImages = tabIndexMotor[selectedTabIndex];
    if (Array.isArray(selectedTabImages)) {
      return selectedTabImages.map((image, index) => {
        const { x, y, width, height, name, zIndex, hideChannel, hideValue } =
          image;

        const hideChannelData = tableData.find((d) => d.Header === hideChannel);

        let isHide = false;
        if (hideChannelData && hideValue !== undefined) {
          isHide = hideChannelData.val.toString() === hideValue.toString();
        }

        const imageStyle = {
          display: isHide ? 'none' : 'flex',
          position: 'absolute',
          top: y + 'px',
          left: x + 'px',
          width: width ? width : '250px',
          height: height ? height : '150px',
          scale: isMobile ? scaleValue.toString() : '1',
          zIndex: zIndex ? zIndex : '1',
        };

        return (
          <div style={imageStyle} key={index}>
            {image.on ? (
              <img src={motorgif} alt="MotorGif" />
            ) : (
              <img src={name} alt="" />
            )}
          </div>
        );
      });
    }
  };

  // Function to generate saved LINE-CHARTS according saved information
  const generateLineChart = () => {
    const selectedTabDevices = tabIndexLineChart[selectedTabIndex];
    if (Array.isArray(selectedTabDevices)) {
      return selectedTabDevices.map((device, index) => {
        const {
          x,
          y,
          id,
          chartChannel,
          width,
          height,
          hour,
          minute,
          zIndex,
          lineStyle,
          isCurveLine,
          isSteppedLine,
          minY,
          maxY,
          xInterval,
          yInterval,
          channelsGroup,
        } = device;

        const filteredDataArrLive = dataArrLive.filter(
          (dataset) => !dataset.label.includes('Event_'),
        );

        const deviceStyle = {
          position: 'absolute',
          top: y + 'px',
          left: x + 'px',
          backgroundColor: '#fff',
          width: isMobile ? '120%' : width ? width : '40%',
          scale: isMobile ? scaleValue.toString() : '1',
          borderRadius: '.625rem',
          zIndex: zIndex ? zIndex : '1',
        };

        return (
          <>
            <div style={deviceStyle} key={index}>
              <LineChart
                openNewPage={openNewPage}
                dateTimesLive={dateTimesLive}
                channelNames={channelNames}
                dataArrLive={filteredDataArrLive}
                getRandomColor={getRandomColor}
                chartChannel={chartChannel}
                selectedTabIndex={selectedTabIndex}
                id={id}
                data={data}
                hour={hour}
                minute={minute}
                oneDayDataTs={oneDayDataTs}
                lineStyle={lineStyle}
                isCurveLine={isCurveLine}
                isSteppedLine={isSteppedLine}
                minY={minY}
                maxY={maxY}
                xInterval={xInterval}
                yInterval={yInterval}
                width={width}
                height={height}
                channelsGroup={channelsGroup}
                allChannelGroups={allChannelGroups}
              />
            </div>
          </>
        );
      });
    }
  };

  // Function to generate saved PIE-CHARTS according saved information
  const generatePieChart = () => {
    const selectedTabDevices = tabIndexPieChart[selectedTabIndex];

    if (Array.isArray(selectedTabDevices)) {
      return selectedTabDevices.map((device, index) => {
        const { x, y, id, chartChannel, width, zIndex, channelsGroup } = device;

        const filteredDataArrLive = dataArrLive.filter(
          (dataset) => !dataset.label.includes('Event_'),
        );

        const deviceStyle = {
          position: 'absolute',
          top: y + 'px',
          left: x + 'px',
          width: isMobile ? '100%' : width ? width : '27%',
          scale: isMobile ? scaleValue.toString() : '1',
          zIndex: zIndex ? zIndex : '1',
        };

        return (
          <>
            <div style={deviceStyle} key={index}>
              <PieChart
                openNewPage={openNewPage}
                dateTimesLive={dateTimesLive}
                channelNames={channelNames}
                dataArrLive={filteredDataArrLive}
                getRandomColor={getRandomColor}
                chartChannel={chartChannel}
                tabIndexPieChart={tabIndexPieChart}
                selectedTabIndex={selectedTabIndex}
                id={id}
                channelsGroup={channelsGroup}
                allChannelGroups={allChannelGroups}
              />
            </div>
          </>
        );
      });
    }
  };

  // Function to generate saved BAR-CHARTS according saved information
  const generateBarChart = () => {
    const selectedTabDevices = tabIndexBarChart[selectedTabIndex];

    if (Array.isArray(selectedTabDevices)) {
      return selectedTabDevices.map((device, index) => {
        const { x, y, chartChannel, width, height, zIndex, channelsGroup } =
          device;
        const deviceStyle = {
          backgroundColor: '#fff',
          position: 'absolute',
          top: y + 'px',
          left: x + 'px',
          width: isMobile ? '120%' : width ? width : '40%',
          height: height,
          borderRadius: '.625rem',
          scale: isMobile ? scaleValue.toString() : '1',
          zIndex: zIndex ? zIndex : '1',
        };

        const filteredDataArrLive = dataArrLive.filter(
          (dataset) => !dataset.label.includes('Event_'),
        );

        return (
          <>
            <div style={deviceStyle} key={index}>
              <BarChart
                openNewPage={openNewPage}
                dateTimesLive={dateTimesLive}
                channelNames={channelNames}
                dataArrLive={filteredDataArrLive}
                getRandomColor={getRandomColor}
                setBarChartData={setBarChartData}
                chartChannel={chartChannel}
                tabIndexBarChart={tabIndexBarChart}
                selectedTabIndex={selectedTabIndex}
                barChartData={barChartData}
                channelsGroup={channelsGroup}
                allChannelGroups={allChannelGroups}
              />
            </div>
          </>
        );
      });
    }
  };

  // Function to generate saved HISTOGRAMS according saved information
  const generateHistogram = () => {
    const selectedTabDevices = tabIndexHistogram[selectedTabIndex];

    if (Array.isArray(selectedTabDevices)) {
      return selectedTabDevices.map((device, index) => {
        const {
          x,
          y,
          chartChannel,
          width,
          hour,
          minute,
          zIndex,
          channelsGroup,
        } = device;

        const filteredDataArrLive = dataArrLive.filter(
          (dataset) => !dataset.label.includes('Event_'),
        );

        const deviceStyle = {
          backgroundColor: '#fff',
          position: 'absolute',
          top: y + 'px',
          left: x + 'px',
          width: isMobile ? '120%' : width ? width : '40%',
          borderRadius: '.625rem',
          scale: isMobile ? scaleValue.toString() : '1',
          zIndex: zIndex ? zIndex : '1',
        };

        return (
          <>
            <div style={deviceStyle} key={index}>
              <Histogram
                openNewPage={openNewPage}
                dateTimesLive={dateTimesLive}
                channelNames={channelNames}
                dataArrLive={filteredDataArrLive}
                getRandomColor={getRandomColor}
                setHistogramData={setHistogramData}
                chartChannel={chartChannel}
                tabIndexBarChart={tabIndexBarChart}
                selectedTabIndex={selectedTabIndex}
                histogramData={histogramData}
                oneDayDataTs={oneDayDataTs}
                hour={hour}
                minute={minute}
                channelsGroup={channelsGroup}
                allChannelGroups={allChannelGroups}
              />
            </div>
          </>
        );
      });
    }
  };

  // Function to generate saved GUAGES according saved information
  const generateGauge = () => {
    const selectedTabDevices = tabIndexGauge[selectedTabIndex];

    if (Array.isArray(selectedTabDevices)) {
      return selectedTabDevices.map((device, index) => {
        const { x, y, minVal, maxVal, chartChannel, width, zIndex, fontSize } =
          device;

        const chartChannelArray =
          typeof chartChannel === 'string' ? [chartChannel] : chartChannel;

        const deviceStyle = {
          position: 'absolute',
          top: y + 'px',
          left: x + 'px',
          width: isMobile ? '70%' : width !== null ? width : '20%',
          scale: isMobile ? scaleValue.toString() : '1',
          zIndex: zIndex ? zIndex : '1',
        };

        return (
          <>
            <div style={deviceStyle} key={index}>
              <Gauge
                openNewPage={openNewPage}
                dateTimesLive={dateTimesLive}
                channelNames={channelNames}
                dataArrLive={dataArrLive}
                getRandomColor={getRandomColor}
                chartChannel={chartChannelArray}
                tabIndexBarChart={tabIndexBarChart}
                selectedTabIndex={selectedTabIndex}
                minVal={minVal}
                maxVal={maxVal}
                fontSize={fontSize}
                isMobile={isMobile}
              />
            </div>
          </>
        );
      });
    }
  };

  // Function to generate saved PROGRESSBARS according saved information
  const generateProgressBar = () => {
    const selectedTabDevices = tabIndexProgress[selectedTabIndex];

    if (Array.isArray(selectedTabDevices)) {
      return selectedTabDevices.map((device, index) => {
        const {
          x,
          y,
          minVal,
          maxVal,
          chartChannel,
          rotate,
          height,
          width,
          fontSize,
          bgColor,
          zIndex,
        } = device;

        const chartChannelArray =
          typeof chartChannel === 'string' ? [chartChannel] : chartChannel;

        const deviceStyle = {
          position: 'absolute',
          top: y + 'px',
          left: x + 'px',
          display: rotate ? 'flex' : null,
          justifyContent: rotate ? 'center' : null,
          alignItems: rotate ? 'center' : null,
          height: height ? height : '',
          width: width ? width : '20%',
          scale: isMobile ? scaleValue.toString() : '1',
          zIndex: zIndex ? zIndex : '1',
        };

        return (
          <>
            <div style={deviceStyle} key={index}>
              <ProgressBar
                openNewPage={openNewPage}
                dateTimesLive={dateTimesLive}
                channelNames={channelNames}
                dataArrLive={dataArrLive}
                getRandomColor={getRandomColor}
                chartChannel={chartChannelArray}
                tabIndexProgress={tabIndexProgress}
                selectedTabIndex={selectedTabIndex}
                minVal={minVal}
                maxVal={maxVal}
                fontSize={fontSize}
                rotate={rotate}
                bgColor={bgColor}
              />
            </div>
          </>
        );
      });
    }
  };

  // Function to generate saved GRIDS according saved information
  const generateGrid = () => {
    const selectedTabDevices = tabIndexGrid[selectedTabIndex];
    if (Array.isArray(selectedTabDevices)) {
      return selectedTabDevices.map((device, index) => {
        const { x, y, chartChannel, width, height, zIndex } = device;

        const deviceStyle = {
          position: 'absolute',
          top: y + 'px',
          left: x + 'px',
          width: width,
          height: height,
          scale: isMobile ? scaleValue.toString() : '1',
          zIndex: zIndex ? zIndex : '1',
        };

        return (
          <>
            <div style={deviceStyle} key={index}>
              <ToolBarGrid chartChannel={chartChannel} tableData={tableData} />
            </div>
          </>
        );
      });
    }
  };

  // Function to generate saved TABLES according saved information
  const generateTable = () => {
    const selectedTabDevices = tabIndexTable[selectedTabIndex];
    if (Array.isArray(selectedTabDevices)) {
      return selectedTabDevices.map((device, index) => {
        const { x, y, width, chartChannel, column, height, zIndex } = device;

        const deviceStyle = {
          position: 'absolute',
          top: y + 'px',
          left: x + 'px',
          width: width,
          height: height,
          scale: isMobile ? scaleValue.toString() : '1',
          zIndex: zIndex ? zIndex : '1',
        };

        return (
          <>
            <div style={deviceStyle} key={index}>
              <MovableTable
                openNewPage={openNewPage}
                dateTimesLive={dateTimesLive}
                channelNames={channelNames}
                chartChannel={chartChannel}
                dataArrLive={dataArrLive}
                getRandomColor={getRandomColor}
                tabIndexProgress={tabIndexProgress}
                selectedTabIndex={selectedTabIndex}
                column={column}
              />
            </div>
          </>
        );
      });
    }
  };

  const generateCircularProgress = () => {
    const selectedTabDevices = tabIndexCircularProgress[selectedTabIndex];
    if (Array.isArray(selectedTabDevices)) {
      return selectedTabDevices.map((device, index) => {
        const { x, y, chartChannel, width, height, maxVal, zIndex } = device;

        const deviceStyle = {
          position: 'absolute',
          left: x + 'px',
          top: y + 'px',
          padding: '.2rem',
          width: width ? width : '100px',
          height: height ? height : '100px',
          zIndex: zIndex ? zIndex : '1',
        };

        return (
          <>
            <div style={deviceStyle} key={index}>
              <CircularProgressChart
                progress={60}
                chartChannel={chartChannel}
                dateTimesLive={dateTimesLive}
                dataArrLive={dataArrLive}
                maxVal={maxVal}
              />
            </div>
          </>
        );
      });
    }
  };

  const generateDoughnut = () => {
    const selectedTabDevices = tabIndexDoughnut[selectedTabIndex];
    if (Array.isArray(selectedTabDevices)) {
      return selectedTabDevices.map((device, index) => {
        const { x, y, chartChannel, width, height, zIndex } = device;

        const deviceStyle = {
          position: 'absolute',
          left: x + 'px',
          top: y + 'px',
          width: width ? width : '150px',
          height: height ? height : '150px',
          zIndex: zIndex ? zIndex : '1',
        };

        const filteredDataArrLive = dataArrLive.filter(
          (dataset) => !dataset.label.includes('Event_'),
        );

        return (
          <>
            <div style={deviceStyle} key={index}>
              <DoughnutChart
                dataArrLive={filteredDataArrLive}
                chartChannel={chartChannel}
                getRandomColor={getRandomColor}
              />
            </div>
          </>
        );
      });
    }
  };

  const generateLines = () => {
    const selectedTabImages = tabIndexLines[selectedTabIndex];
    if (Array.isArray(selectedTabImages)) {
      return selectedTabImages.map((line, index) => {
        const {
          x,
          y,
          width,
          height,
          length,
          deltaX,
          deltaY,
          angle,
          zIndex,
          hideChannel,
          hideValue,
          blinkChannel,
          blinkValue,
          blinkFunction,
          blinkFrequency,
          bgColor,
          conditionValue,
          moveValue,
          horizontalMoveChannel,
          verticalMoveChannel,
        } = line;

        const hideChannelData = tableData.find((d) => d.Header === hideChannel);

        const blinkChannelData = tableData.find(
          (d) => d.Header === blinkChannel,
        );

        let isHide = false;
        if (hideChannelData && hideValue !== undefined) {
          isHide = hideChannelData.val.toString() === hideValue.toString();
        }

        // -------- BLINK LOGIC ----------
        let shouldBlink = false;
        let blinkSpeed = '1s';

        if (blinkChannelData) {
          shouldBlink = shouldBlinkWidget(
            blinkChannelData.val,
            blinkValue,
            blinkFunction,
          );

          blinkSpeed = blinkFrequency ? `${blinkFrequency / 1000}s` : '1s';
        }

        const horizontalChannelData = tableData.find(
          (d) => d.Header === horizontalMoveChannel,
        );

        const verticalChannelData = tableData.find(
          (d) => d.Header === verticalMoveChannel,
        );

        let leftPosition = x ? parseFloat(x) : 0;

        if (
          horizontalChannelData &&
          conditionValue &&
          moveValue &&
          conditionValue.toLeft !== undefined &&
          conditionValue.toRight !== undefined &&
          moveValue.toLeft !== undefined &&
          moveValue.toRight !== undefined
        ) {
          const currentVal = Number(horizontalChannelData.val);
          const rangeMin = Number(conditionValue.toLeft);
          const rangeMax = Number(conditionValue.toRight);
          const moveMin = Number(moveValue.toLeft);
          const moveMax = Number(moveValue.toRight);

          if (currentVal >= rangeMin && currentVal <= rangeMax) {
            const ratio = (currentVal - rangeMin) / (rangeMax - rangeMin);

            leftPosition = moveMin + ratio * (moveMax - moveMin);
          }
        }

        let topPosition = y ? parseFloat(y) : 0;

        if (
          verticalChannelData &&
          conditionValue &&
          moveValue &&
          conditionValue.toTop !== undefined &&
          conditionValue.toBottom !== undefined &&
          moveValue.toTop !== undefined &&
          moveValue.toBottom !== undefined
        ) {
          const currentVal = Number(verticalChannelData.val);
          const rangeMin = Number(conditionValue.toTop);
          const rangeMax = Number(conditionValue.toBottom);
          const moveMin = Number(moveValue.toTop);
          const moveMax = Number(moveValue.toBottom);

          if (currentVal >= rangeMin && currentVal <= rangeMax) {
            const ratio = (currentVal - rangeMin) / (rangeMax - rangeMin);

            topPosition = moveMin + ratio * (moveMax - moveMin);
          }
        }

        return (
          <div
            style={{
              position: 'absolute',
              top: `${topPosition}px`,
              left: `${leftPosition}px`,
              width: `${Number(width) + 3}px`,
              height: `${Number(height) + 3}px`,
              zIndex: zIndex ? zIndex : '1',
              display: isHide ? 'none' : 'block',
              animationDuration: shouldBlink ? blinkSpeed : '0s',
            }}
          >
            <div
              style={{
                position: 'absolute',

                left: deltaX >= 0 ? 0 : Math.abs(deltaX),
                top: deltaY >= 0 ? 0 : Math.abs(deltaY),

                width: `${length}px`,
                height: '2px',
                backgroundColor: bgColor ? bgColor : 'black',

                transformOrigin: '0 0',
                transform: `rotate(${angle}deg)`,
              }}
              key={index}
            ></div>
          </div>
        );
      });
    }
  };

  const generateSquare = () => {
    const selectedTabImages = tabIndexSquare[selectedTabIndex];

    if (!Array.isArray(selectedTabImages)) return null;

    return selectedTabImages.map((line, index) => {
      const {
        onText,
        offText,
        text,
        onColor,
        offColor,
        fontSize,
        bgColor,
        channelName,
        width,
        height,
        x,
        y,
        textColor,
        hideChannel,
        hideValue,
        zIndex,
        borderRadius,

        // Movement
        horizontalMoveChannel,
        verticalMoveChannel,
        conditionValue,
        moveValue,
        blinkChannel,
        blinkValue,
        blinkFunction,
        blinkFrequency,
      } = line;

      //      CHANNEL LOOKUPS

      const statusChannel = tableData.find((d) => d.Header === channelName?.PV);

      const hideChannelData = tableData.find((d) => d.Header === hideChannel);

      const horizontalChannelData = tableData.find(
        (d) => d.Header === horizontalMoveChannel,
      );

      const verticalChannelData = tableData.find(
        (d) => d.Header === verticalMoveChannel,
      );

      const blinkChannelData = tableData.find((d) => d.Header === blinkChannel);

      let statusText = text;
      let statusColor = bgColor;

      if (statusChannel) {
        if (statusChannel.val === 1) {
          statusText = onText;
          statusColor = onColor;
        } else if (statusChannel.val === 0) {
          statusText = offText;
          statusColor = offColor;
        }
      }

      // -------- BLINK LOGIC ----------
      let shouldBlink = false;
      let blinkSpeed = '1s';

      if (blinkChannelData) {
        shouldBlink = shouldBlinkWidget(
          blinkChannelData.val,
          blinkValue,
          blinkFunction,
        );

        blinkSpeed = blinkFrequency ? `${blinkFrequency / 1000}s` : '1s';
      }

      //     HIDE LOGIC

      let isHide = false;
      if (hideChannelData && hideValue !== undefined) {
        isHide = hideChannelData.val.toString() === hideValue.toString();
      }

      // HORIZONTAL MOVEMENT

      let leftPosition = x ? parseFloat(x) : 0;

      if (
        horizontalChannelData &&
        conditionValue &&
        moveValue &&
        conditionValue.toLeft !== undefined &&
        conditionValue.toRight !== undefined &&
        moveValue.toLeft !== undefined &&
        moveValue.toRight !== undefined
      ) {
        const currentVal = Number(horizontalChannelData.val);
        const rangeMin = Number(conditionValue.toLeft);
        const rangeMax = Number(conditionValue.toRight);
        const moveMin = Number(moveValue.toLeft);
        const moveMax = Number(moveValue.toRight);

        if (currentVal >= rangeMin && currentVal <= rangeMax) {
          const ratio = (currentVal - rangeMin) / (rangeMax - rangeMin);

          leftPosition = moveMin + ratio * (moveMax - moveMin);
        }
      }

      let topPosition = y ? parseFloat(y) : 0;

      if (
        verticalChannelData &&
        conditionValue &&
        moveValue &&
        conditionValue.toTop !== undefined &&
        conditionValue.toBottom !== undefined &&
        moveValue.toTop !== undefined &&
        moveValue.toBottom !== undefined
      ) {
        const currentVal = Number(verticalChannelData.val);
        const rangeMin = Number(conditionValue.toTop);
        const rangeMax = Number(conditionValue.toBottom);
        const moveMin = Number(moveValue.toTop);
        const moveMax = Number(moveValue.toBottom);

        if (currentVal >= rangeMin && currentVal <= rangeMax) {
          const ratio = (currentVal - rangeMin) / (rangeMax - rangeMin);

          topPosition = moveMin + ratio * (moveMax - moveMin);
        }
      }

      const deviceStyle = {
        width: width || '100px',
        height: height || '100px',
        position: 'absolute',
        left: `${leftPosition}px`,
        top: `${topPosition}px`,
        border: '1px solid black',
        background: statusColor || 'white',
        display: isHide ? 'none' : 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: fontSize ? `${fontSize}px` : '14px',
        color: textColor || 'black',
        transition: 'left 0.3s linear, top 0.3s linear',
        zIndex: zIndex ? zIndex : '1',
        animationDuration: shouldBlink ? blinkSpeed : '0s',
        borderRadius: `${borderRadius?.toString()}%`
          ? `${borderRadius?.toString()}%`
          : 'none',
      };

      return (
        <div
          key={index}
          style={deviceStyle}
          className={`${shouldBlink ? styles.blinkWidget : ''}`}
        >
          {statusText}
        </div>
      );
    });
  };

  const generateCircle = () => {
    const selectedTabImages = tabIndexCircle[selectedTabIndex];
    if (Array.isArray(selectedTabImages)) {
      return selectedTabImages.map((circle, index) => {
        const {
          onText,
          offText,
          text,
          onColor,
          offColor,
          fontSize,
          bgColor,
          channelName,
          width,
          height,
          x,
          y,
          textColor,
          hideChannel,
          hideValue,
          zIndex,

          // Movement
          horizontalMoveChannel,
          verticalMoveChannel,
          conditionValue,
          moveValue,
          blinkChannel,
          blinkValue,
          blinkFunction,
          blinkFrequency,
        } = circle;

        //      CHANNEL LOOKUPS

        const statusChannel = tableData.find(
          (d) => d.Header === channelName?.PV,
        );

        const hideChannelData = tableData.find((d) => d.Header === hideChannel);

        const horizontalChannelData = tableData.find(
          (d) => d.Header === horizontalMoveChannel,
        );

        const verticalChannelData = tableData.find(
          (d) => d.Header === verticalMoveChannel,
        );

        const blinkChannelData = tableData.find(
          (d) => d.Header === blinkChannel,
        );

        let statusText = text;
        let statusColor = bgColor;

        if (statusChannel) {
          if (statusChannel.val === 1) {
            statusText = onText;
            statusColor = onColor;
          } else if (statusChannel.val === 0) {
            statusText = offText;
            statusColor = offColor;
          }
        }

        //     HIDE LOGIC

        let isHide = false;
        if (hideChannelData && hideValue !== undefined) {
          isHide = hideChannelData.val.toString() === hideValue.toString();
        }

        // HORIZONTAL MOVEMENT

        let leftPosition = x ? parseFloat(x) : 0;

        if (
          horizontalChannelData &&
          conditionValue &&
          moveValue &&
          conditionValue.toLeft !== undefined &&
          conditionValue.toRight !== undefined &&
          moveValue.toLeft !== undefined &&
          moveValue.toRight !== undefined
        ) {
          const currentVal = Number(horizontalChannelData.val);
          const rangeMin = Number(conditionValue.toLeft);
          const rangeMax = Number(conditionValue.toRight);
          const moveMin = Number(moveValue.toLeft);
          const moveMax = Number(moveValue.toRight);

          if (currentVal >= rangeMin && currentVal <= rangeMax) {
            const ratio = (currentVal - rangeMin) / (rangeMax - rangeMin);

            leftPosition = moveMin + ratio * (moveMax - moveMin);
          }
        }

        let topPosition = y ? parseFloat(y) : 0;

        if (
          verticalChannelData &&
          conditionValue &&
          moveValue &&
          conditionValue.toTop !== undefined &&
          conditionValue.toBottom !== undefined &&
          moveValue.toTop !== undefined &&
          moveValue.toBottom !== undefined
        ) {
          const currentVal = Number(verticalChannelData.val);
          const rangeMin = Number(conditionValue.toTop);
          const rangeMax = Number(conditionValue.toBottom);
          const moveMin = Number(moveValue.toTop);
          const moveMax = Number(moveValue.toBottom);

          if (currentVal >= rangeMin && currentVal <= rangeMax) {
            const ratio = (currentVal - rangeMin) / (rangeMax - rangeMin);

            topPosition = moveMin + ratio * (moveMax - moveMin);
          }
        }

        // -------- BLINK LOGIC ----------
        let shouldBlink = false;
        let blinkSpeed = '1s';

        if (blinkChannelData) {
          shouldBlink = shouldBlinkWidget(
            blinkChannelData.val,
            blinkValue,
            blinkFunction,
          );

          blinkSpeed = blinkFrequency ? `${blinkFrequency / 1000}s` : '1s';
        }

        const deviceStyle = {
          width: width ? width : '100px',
          height: height ? height : '100px',
          position: 'absolute',
          left: `${leftPosition}px`,
          top: `${topPosition}px`,
          border: '1px solid black',
          background: statusColor || 'white',
          borderRadius: '50%',
          overflow: 'hidden',
          display: isHide ? 'none' : 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: fontSize ? `${fontSize}px` : '14px',
          transition: 'left 0.3s linear, top 0.3s linear',
          color: textColor ? textColor : 'black',
          zIndex: zIndex ? zIndex : '1',
          animationDuration: shouldBlink ? blinkSpeed : '0s',
        };

        return (
          <div style={deviceStyle} key={index}>
            {statusText}
          </div>
        );
      });
    }
  };

  const generatePolygone = () => {
    const selectedTabImages = tabIndexPolygone[selectedTabIndex];

    if (selectedTabImages && Array.isArray(selectedTabImages)) {
      return selectedTabImages.map((polygone, index) => {
        const {
          x,
          y,
          width,
          height,
          bgColor,
          points,
          zIndex,
          hideChannel,
          hideValue,
        } = polygone;

        const hideChannelData = tableData.find((d) => d.Header === hideChannel);

        let isHide = false;
        if (hideChannelData && hideValue !== undefined) {
          isHide = hideChannelData.val.toString() === hideValue.toString();
        }

        return (
          <div
            style={{
              display: isHide ? 'none' : '',
              position: 'absolute',
              left: x ? x + 'px' : '0',
              top: y ? y + 'px' : '0',
              width: width,
              height: height,
              overflow: 'hidden',
              pointerEvents: 'auto',
              zIndex: zIndex ? zIndex : '1',
            }}
            className={styles.addImg}
          >
            <Stage
              width={Number(width)}
              height={Number(height)}
              style={{ width: '100%', height: '100%' }}
            >
              <Layer>
                <Line
                  points={points}
                  stroke="blue"
                  fill={bgColor ?? 'rgba(0, 0, 255, 0.3)'}
                  strokeWidth={2}
                  closed={true}
                />
              </Layer>
            </Stage>
          </div>
        );
      });
    }
  };

  const generatePipe = () => {
    const selectedTabImages = tabIndexPipe[selectedTabIndex];
    if (selectedTabImages && Array.isArray(selectedTabImages)) {
      return selectedTabImages.map((pipe, index) => {
        const {
          x,
          y,
          width,
          height,
          bgColor,
          textColor,
          points,
          zIndex,
          channelName,
          hideChannel,
          hideValue,
        } = pipe;

        let isFlow = false;

        const flowChannel = tableData.find(
          (channel) => channel.Header === channelName?.PV,
        );

        if (flowChannel && flowChannel?.val && Number(flowChannel?.val === 1)) {
          isFlow = true;
        }

        const strokeBorder = 17;
        const strokeOuter = 14;
        const strokeInner = 10;
        const padding = strokeOuter;

        const paddedPoints = points.map((val, i) => val + padding);

        const hideChannelData = tableData.find((d) => d.Header === hideChannel);

        let isHide = false;
        if (hideChannelData && hideValue !== undefined) {
          isHide = hideChannelData.val.toString() === hideValue.toString();
        }

        return (
          <div
            style={{
              display: isHide ? 'none' : '',
              position: 'absolute',
              left: `${x - padding}px`, // shift left
              top: `${y - padding}px`, // shift top
              width: `${Number(width) + padding * 2}px`, // extra padding
              height: `${Number(height) + padding * 2}px`,
              resize: 'both',
              overflow: 'visible',
              pointerEvents: 'auto',
              zIndex: zIndex ? zIndex : '1',
            }}
            className={styles.addImg}
          >
            <Stage
              width={Number(width) + padding * 2}
              height={Number(height) + padding * 2}
            >
              <Layer ref={layerRef}>
                {/* PIPE BORDER */}
                <Line
                  points={paddedPoints}
                  stroke="#444" //  black border
                  strokeWidth={strokeBorder} //  slightly bigger
                  lineCap="butt"
                  lineJoin="round"
                  shadowForStrokeEnabled={false}
                />
                {/* PIPE BACKGROUND */}

                <Line
                  points={paddedPoints}
                  stroke={bgColor || '#a8c4d9'} //  background color
                  strokeWidth={strokeOuter}
                  lineCap="butt"
                  lineJoin="round"
                  shadowForStrokeEnabled={false}
                />

                {/* PIPE FLOW */}

                {isFlow && (
                  <Line
                    ref={(el) => (lineRefs.current[index] = el)}
                    points={paddedPoints}
                    stroke={textColor || '#444'} // dashed / flow color
                    strokeWidth={strokeInner}
                    lineCap="round"
                    lineJoin="round"
                    shadowForStrokeEnabled={false}
                    dash={[20, 25]}
                  />
                )}
              </Layer>
            </Stage>
          </div>
        );
      });
    }
  };

  const generateSwitch = () => {
    const selectedTabImages = tabIndexSwitch[selectedTabIndex];
    if (Array.isArray(selectedTabImages)) {
      return selectedTabImages.map((sw, index) => {
        const { x, y, chartChannel, zIndex, hideChannel, hideValue, bgColor } =
          sw;

        let isOn = 0;
        if (chartChannel) {
          const matchedDatasets =
            chartChannel?.length === 0
              ? null
              : dataArrLive?.find(
                (dataset) => dataset.label === chartChannel[0],
              );

          const currentVal = matchedDatasets
            ? matchedDatasets?.data.slice(-1)
            : [0];
          if (currentVal && currentVal[0]) {
            isOn = parseInt(currentVal[0]) === 1 ? true : false;
          }
        }

        const hideChannelData = tableData.find((d) => d.Header === hideChannel);

        let isHide = false;
        if (hideChannelData && hideValue !== undefined) {
          isHide = hideChannelData.val.toString() === hideValue.toString();
        }

        const deviceStyle = {
          position: 'absolute',
          left: x ? x + 'px' : '0px',
          top: y ? y + 'px' : '40px',
          display: isHide ? 'none' : 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '80px',
          height: '50px',
          zIndex: zIndex ? zIndex : '1',
        };

        return (
          <div style={deviceStyle}>
            <CustomSwitch on={isOn} bgColor={bgColor} />
          </div>
        );
      });
    }
  };

  const generateCheckbox = () => {
    const selectedTabImages = tabIndexCheckbox[selectedTabIndex];
    if (Array.isArray(selectedTabImages)) {
      return selectedTabImages.map((sw, index) => {
        const { x, y, width, height, on, zIndex, hideChannel, hideValue } = sw;

        const hideChannelData = tableData.find((d) => d.Header === hideChannel);

        let isHide = false;
        if (hideChannelData && hideValue !== undefined) {
          isHide = hideChannelData.val.toString() === hideValue.toString();
        }

        const deviceStyle = {
          position: 'absolute',
          left: x ? x + 'px' : '0px',
          top: y ? y + 'px' : '40px',
          display: isHide ? 'none' : 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: width ? width : '15px',
          height: height ? height : '15px',

          zIndex: zIndex ? zIndex : '1',
        };

        return (
          <div style={deviceStyle}>
            <input
              type="checkbox"
              checked={on}
              style={{ width: '100%', height: '100%' }}
            />
          </div>
        );
      });
    }
  };

  const generateRadio = () => {
    const selectedTabImages = tabIndexRadio[selectedTabIndex];
    if (Array.isArray(selectedTabImages)) {
      return selectedTabImages.map((sw, index) => {
        const {
          x,
          y,
          width,
          height,
          points,
          selectedIndex,
          zIndex,
          hideChannel,
          hideValue,
        } = sw;

        const hideChannelData = tableData.find((d) => d.Header === hideChannel);

        let isHide = false;

        if (hideChannelData && hideValue !== undefined) {
          isHide = hideChannelData.val.toString() === hideValue.toString();
        }

        const deviceStyle = {
          position: 'absolute',
          left: x ? x + 'px' : '0px',
          top: y ? y + 'px' : '40px',
          display: isHide ? 'none' : 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: '0.5rem',
          alignItems: 'center',
          width: width ? width : '50px',
          height: height ? height : '50px',
          zIndex: zIndex ? zIndex : '1',
        };

        return (
          <div style={deviceStyle}>
            {points?.map((btn, i) => (
              <input
                type="radio"
                name={`group${index}`}
                style={{ flex: '1', width: '100%', cursor: 'pointer' }}
                checked={selectedIndex === i}
              />
            ))}
          </div>
        );
      });
    }
  };

  const generateSlider = () => {
    const selectedTabImages = tabIndexSlider[selectedTabIndex];
    if (Array.isArray(selectedTabImages)) {
      return selectedTabImages.map((device, index) => {
        const {
          x,
          y,
          minVal,
          maxVal,
          chartChannel,
          bgColor,
          width,
          zIndex,
          hideChannel,
          hideValue,
          fontSize,
          textColor,
        } = device;

        const hideChannelData = tableData.find((d) => d.Header === hideChannel);

        let isHide = false;
        if (hideChannelData && hideValue !== undefined) {
          isHide = hideChannelData.val.toString() === hideValue.toString();
        }

        let tranChartChannel =
          chartChannel && Array.isArray(chartChannel)
            ? chartChannel
            : [chartChannel];

        const deviceStyle = {
          position: 'absolute',
          left: x ? x + 'px' : '0px',
          top: y ? y + 'px' : '40px',
          display: isHide ? 'none' : 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: width ? width : '190px',
          zIndex: zIndex ? zIndex : '1',
          color: textColor ? textColor : 'black',
        };

        return (
          <div style={deviceStyle}>
            <Slider
              minVal={minVal}
              maxVal={maxVal}
              chartChannel={tranChartChannel}
              dateTimesLive={dateTimesLive}
              dataArrLive={dataArrLive}
              bgColor={bgColor}
              fontSize={fontSize}
            />
          </div>
        );
      });
    }
  };

  const generateLamp = () => {
    const selectedTabImages = tabIndexLamp[selectedTabIndex];
    if (Array.isArray(selectedTabImages)) {
      return selectedTabImages.map((device, index) => {
        const {
          x,
          y,
          chartChannel,
          height,
          width,
          zIndex,
          lampStatus,
          hideChannel,
          hideValue,
        } = device;

        let lampColor = 'grey';

        if (
          chartChannel &&
          Array.isArray(chartChannel) &&
          chartChannel.length > 0
        ) {
          const statusChannel = tableData.find(
            (d) => d.Header === chartChannel[0],
          );

          if (statusChannel && statusChannel.val) {
            const foundLampStatus = lampStatus?.filter(
              (status) =>
                Number(status.conditionValue) === Number(statusChannel.val),
            );

            if (Array.isArray(foundLampStatus) && foundLampStatus.length > 0) {
              lampColor = foundLampStatus[0]?.color;
            }
          }
        }

        const hideChannelData = tableData.find((d) => d.Header === hideChannel);

        let isHide = false;
        if (hideChannelData && hideValue !== undefined) {
          isHide = hideChannelData.val.toString() === hideValue.toString();
        }

        const deviceStyle = {
          position: 'absolute',
          left: x ? x : '0px',
          top: y ? y : '40px',
          display: isHide ? 'none' : 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: width ? width : '100px',
          height: height ? height : '100px',
          zIndex: zIndex ? zIndex : '1',
        };

        return (
          <div style={deviceStyle}>
            <BulbIcon color={lampColor} />
          </div>
        );
      });
    }
  };

  const generatePush = () => {
    const selectedTabImages = tabIndexPush[selectedTabIndex];
    if (Array.isArray(selectedTabImages)) {
      return selectedTabImages.map((push, index) => {
        const { x, y, width, height, bgColor, zIndex, hideChannel, hideValue } =
          push;

        const hideChannelData = tableData.find((d) => d.Header === hideChannel);

        let isHide = false;
        if (hideChannelData && hideValue !== undefined) {
          isHide = hideChannelData.val.toString() === hideValue.toString();
        }

        const deviceStyle = {
          width: width ? width : '100px',
          height: height ? height : '100px',
          position: 'absolute',
          left: x ? x : '0px',
          top: y ? y : '40px',
          border: '1px solid black',
          background: 'red',
          borderRadius: '50%',
          overflow: 'hidden',
          display: isHide ? 'none' : 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: zIndex ? zIndex : '1',
        };

        return (
          <div style={deviceStyle} key={index}>
            <span>OFF</span>
          </div>
        );
      });
    }
  };

  // Function to generate saved TEXTS according saved information
  const generateLink = () => {
    const selectedTabDevices = tabIndexLink[selectedTabIndex];
    if (Array.isArray(selectedTabDevices)) {
      return selectedTabDevices.map((device, index) => {
        const {
          x,
          y,
          width,
          height,
          bgColor,
          textColor,
          text,
          fontSize,
          alignHorizontally,
          alignVertically,
          hideChannel,
          hideValue,
          zIndex,
        } = device;

        const hideChannelData = tableData.find((d) => d.Header === hideChannel);

        let isHide = false;
        if (hideChannelData && hideValue !== undefined) {
          isHide = hideChannelData.val.toString() === hideValue.toString();
        }

        const deviceStyle = {
          position: 'absolute',
          top: y + 'px',
          left: x + 'px',
          backgroundColor: bgColor,
          color: textColor,
          padding: '0.6rem 1rem',
          fontSize: fontSize ? fontSize + 'px' : '30px',
          width: width ? width : undefined,
          height: height ? height : undefined,
          scale: isMobile ? scaleValue.toString() : '1',
          wordBreak: 'break-word',
          justifyContent: alignHorizontally ? alignHorizontally : 'start',
          alignItems: alignVertically ? alignVertically : 'start',
          cursor: 'pointer',
          textDecoration: 'underline',
          zIndex: zIndex ? zIndex : '1',
          display: isHide ? 'none' : 'flex',
        };

        return (
          <>
            <div
              style={deviceStyle}
              key={index}
              onDoubleClick={(e) => handleLinkClick(e, text)}
            >
              {text}
            </div>
          </>
        );
      });
    }
  };

  // Function to generate saved DIGITAL I/O according saved information
  const generateClock = () => {
    const selectedTabDevices = tabIndexClock[selectedTabIndex];
    if (Array.isArray(selectedTabDevices)) {
      return selectedTabDevices.map((device, index) => {
        const { x, y, name, width, height, zIndex, hideChannel, hideValue } =
          device;
        const hideChannelData = tableData.find((d) => d.Header === hideChannel);

        let isHide = false;
        if (hideChannelData && hideValue !== undefined) {
          isHide = hideChannelData.val.toString() === hideValue.toString();
        }

        const deviceStyle = {
          width: width ? width : '100px',
          height: height ? height : '100px',
          position: 'absolute',
          left: x ? x + 'px' : '0px',
          top: y ? y + 'px' : '40px',
          background: 'transparent',
          overflow: 'hidden', // Prevent content overflow
          display: isHide ? 'none' : 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: zIndex ? zIndex : '1',
        };

        return (
          <>
            <div style={deviceStyle} key={index}>
              <Clock />
            </div>
          </>
        );
      });
    }
  };

  // Calling API to get graph data
  useEffect(() => {
    const token = localStorage.getItem('token');
    const graphDataBody = {
      token: token,
      projectId: uniqueProjectId,
      ind: 1,
    };

    try {
      dispatch(getGraphData(graphDataBody));
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    const newSocket = io(portlessProxy, {
      cors: {
        origin: '*',
        allowedHeaders: ['*'],
        allowedMethods: ['GET', 'POST'],
        insecure: true,
      },
    });
    setSocket(newSocket);
    return () => newSocket.close();
  }, [uniqueProjectId]);

  // Starts socket connection
  useEffect(() => {
    if (socket) {
      // Joining the stream of project
      socket.emit('joinRoom', String(uniqueProjectId));
      // On message storing values in state
      socket.on('message', (msg) => {
        let parsedData;

        try {
          parsedData = JSON.parse(msg);
        } catch (error) {
          console.error('Invalid JSON:', error);
          return;
        }
        parsedData = JSON.parse(msg);
        if (parsedData.time && parsedData.Devices) {
          setSocketData(parsedData);
        } else if (!parsedData.time && !parsedData.Devices) {
          parsedData.time = new Date();
          parsedData.Devices = parsedData;
          setSocketData(parsedData);
        } else if (!parsedData.time && parsedData.Devices) {
          parsedData.time = new Date();
          setSocketData(parsedData);
        } else {
          parsedData.Devices = parsedData;
          setSocketData(parsedData);
        }
      });

      socket.on('error', (error) => {
        console.error('Socket error:', error);
      });
    }
    return () => {
      if (socket) {
        socket.off('Connection Closed');
      }
    };
  }, [uniqueProjectId, socket]);

  useEffect(() => {
    if (graphData.length > 0) {
      // Parsing data from from get request in the parent component
      const copiedDataset = [...graphData];
      const fetchData = async () => {
        try {
          if (graphData.length > 0) {
            // Live Data Chart
            const currentTime = new Date();
            currentTime.setTime(currentTime.getTime() - 1 * 60 * 60 * 1000); // Subtracting 1 hour
            const liveDataFiltered = copiedDataset.filter(
              (dataset) => new Date(dataset.time) >= currentTime,
            );
            // Restructure Data for Table
            const tableDataArrayGen = async () => {
              const dataPromise = new Promise((resolve) => {
                tableInitializer.onmessage = (e) => {
                  resolve(e.data);
                };
              });
              tableInitializer.postMessage({ data: liveDataFiltered });
              return await dataPromise;
            };
            console.log(
              'Generating table data array... , tableDataArrayGen : ',
              tableDataArrayGen,
            );
            const tableDataArray = await tableDataArrayGen();
            let gotHeaders = [];

            if (tableDataArray.data) {
              gotHeaders = tableDataArray.headers;
              const arrayOfValueArrays = tableDataArray.channelWiseData;

              const getNewDataArr = () =>
                gotHeaders.map((header, index) => ({
                  label: header,
                  data: arrayOfValueArrays[index],
                  borderColor: getRandomColor(),
                  fill: false,
                }));
              const newDataArr = getNewDataArr();

              setChannelNames(gotHeaders);
              setTableData(tableDataArray.data);
              setDataArrLive(newDataArr);
              setDateTimesLive(tableDataArray.dateTimeArray);
              setInit(true);
            }
          }
        } catch (error) {
          console.log(error);
        }
      };
      fetchData();
    }
  }, [graphData]);

  useEffect(() => {
    tableData.map((data, index) => setHeaderNames(data));
  }, [tableData, graphData]);

  useEffect(() => {
    try {
      const updateData = async () => {
        if (socketData && init && !isWorkerBusy) {
          setIsWorkerBusy(true);
          const structuredData = async () => {
            const dataPromise = new Promise((resolve) => {
              valueExtractor.onmessage = (e) => {
                resolve(e.data);
              };
            });
            valueExtractor.postMessage({
              socketData: socketData,
              currentTable: tableData,
              dateTimeArray: dateTimesLive,
              dataArray: dataArrLive,
              headers: channelNames,
              duration: 1,
            });
            return await dataPromise;
          };
          console.log(
            'Worker is processing data... , structuredData : ',
            structuredData,
          );
          const workerResponse = await structuredData();
          if (workerResponse.updatedTable) {
            setChannelNames(workerResponse.updatedHeaders);
            setTableData(workerResponse.updatedTable);
            setDataArrLive(workerResponse.updatedLiveArray);
            setDateTimesLive(workerResponse.updatedDateTimeArray);
            setOneDayDataTS((prev) => {
              const newTimestamp = new Date().toISOString();

              const updated = [...prev, newTimestamp];

              const first = new Date(updated[0]).getTime();
              const last = new Date(updated[updated.length - 1]).getTime();
              const ONE_DAY = 24 * 60 * 60 * 1000;

              if (last - first > ONE_DAY) {
                updated.shift(); // remove first index
              }
              return updated;
            });
          }
        }
      };
      updateData();
    } catch (error) {
      console.log(error);
    }
    setIsWorkerBusy(false);
  }, [socketData]);

  useEffect(() => {
    // Parsing data from from get request in the parent component
    const fetchData = async () => {
      try {
        if (graphData.length > 0) {
          const copiedDataset = [...graphData];
          // Restructure Data for Table
          const tableDataArrayGen = async () => {
            const dataPromise = new Promise((resolve) => {
              restructureWorker.onmessage = (e) => {
                resolve(e.data);
              };
            });
            restructureWorker.postMessage({ data: copiedDataset });
            return await dataPromise;
          };
          const tableDataArray = await tableDataArrayGen();

          if (tableDataArray.headers.length > 0) {
            setChannelNames(tableDataArray.headers);
            setDataArrLive(tableDataArray.chartArray);
            setOneDayDataTS(tableDataArray.timeArray);
            setInit(true);
          }
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [graphData]);

  useEffect(() => {
    const handleInitVBox = async () => {
      if (!vNetUsername || !vNetPassword) {
        console.log('VNet credentials not provided, skipping login.');
        return;
      }

      const ts = Date.now(); // milliseconds

      const allParams = {
        alias: vNetUsername,
        cuid: cuid,
        lan: 'zh',
        mt: '255',
        password: vNetPassword,
        pid: '1',
        sv: '1.0',
        ts: ts.toString(),
      };

      // Sort alphabetically, join, append fixed key
      const signString =
        Object.keys(allParams)
          .sort()
          .map((k) => `${k}=${allParams[k]}`)
          .join('&') + '&key=5cee621329f24e5cbdc43daa959ce9a1';

      const sign = CryptoJS.MD5(signString).toString();

      const data = {
        vNetUsername,
        vNetPassword,
        cuid,
        ts: ts.toString(),
        sign,
      };

      await dispatch(vNetLogin(data)).then((response) => {
        // console.log("V-net Login Response:", response);

        // Your payload structure is different
        const res = response?.payload?.data;

        if (res?.code === 200) {
          const sid = res?.result?.sid;
          setLoginSid(sid);
        } else {
          console.log('Login failed:', res);
        }
      });
    };

    handleInitVBox();
  }, [vNetUsername, vNetPassword]);

  useEffect(() => {
    const fetchVNetData = async () => {
      if (!vNetSid) return;

      await dispatch(buildTagMap({ cuid, sid: vNetSid, dispatch }));
    };

    fetchVNetData();
  }, [vNetSid]);

  return (
    <>
      {openNewPage ? (
        <NewPage
          setOpenNewPage={setOpenNewPage}
          openNewPage={openNewPage}
          tabNames={tabNames}
          setTabNames={setTabNames}
          data={data}
          socketData={socketData}
          uniqueProjectId={uniqueProjectId}
          images={images}
          setImages={setImages}
          tempImagePosition={tempImagePosition}
          setTempImagePosition={setTempImagePosition}
          tabIndexImages={tabIndexImages}
          setTabIndexImages={setTabIndexImages}
          tableData={tableData}
          apiChannels={apiChannels}
          widgetData={widgetData}
          tabIndexDevices={tabIndexDevices}
          setTabIndexDevices={setTabIndexDevices}
          headerNames={headerNames}
          tabIndexController={tabIndexController}
          setTabIndexController={setTabIndexController}
          tabIndexIO={tabIndexIO}
          setTabIndexIO={setTabIndexIO}
          setTabIndexFlowM={setTabIndexFlowM}
          tabIndexFlowM={tabIndexFlowM}
          tabIndexEnergyM={tabIndexEnergyM}
          setTabIndexEnergyM={setTabIndexEnergyM}
          chartDataLive={chartDataLive}
          tabIndexLineChart={tabIndexLineChart}
          setTabIndexLineChart={setTabIndexLineChart}
          tabIndexPieChart={tabIndexPieChart}
          setTabIndexPieChart={setTabIndexPieChart}
          dateTimesLive={dateTimesLive}
          channelNames={channelNames}
          dataArrLive={dataArrLive}
          getRandomColor={getRandomColor}
          setChartDataLive={setChartDataLive}
          tabIndexBarChart={tabIndexBarChart}
          setTabIndexBarChart={setTabIndexBarChart}
          barChartData={barChartData}
          setBarChartData={setBarChartData}
          tabIndexHistogram={tabIndexHistogram}
          setTabIndexHistogram={setTabIndexHistogram}
          histogramData={histogramData}
          setHistogramData={setHistogramData}
          tabIndexGauge={tabIndexGauge}
          setTabIndexGauge={setTabIndexGauge}
          tabIndexProgress={tabIndexProgress}
          setTabIndexProgress={setTabIndexProgress}
          windowHeight={windowHeight}
          windowWidth={windowWidth}
          screenHeight={screenHeight}
          screenWidth={screenWidth}
          tabIndexGrid={tabIndexGrid}
          setTabIndexGrid={setTabIndexGrid}
          oneDayDataTs={oneDayDataTs}
          tabIndexTable={tabIndexTable}
          setTabIndexTable={setTabIndexTable}
          tabIndexOverviewInfo={tabIndexOverviewInfo}
          setTabIndexOverviewInfo={setTabIndexOverviewInfo}
          tabIndexOverviewGraph={tabIndexOverviewGraph}
          setTabIndexOverviewGraph={setTabIndexOverviewGraph}
          tabIndexLiveDataGraph={tabIndexLiveDataGraph}
          setTabIndexLiveDataGraph={setTabIndexLiveDataGraph}
          tabIndexLastDayTable={tabIndexLastDayTable}
          setTabIndexLastDayTable={setTabIndexLastDayTable}
          tabIndexLastDayGraph={tabIndexLastDayGraph}
          setTabIndexLastDayGraph={setTabIndexLastDayGraph}
          setTabIndexDefaultGrid={setTabIndexDefaultGrid}
          tabIndexDefaultGrid={tabIndexDefaultGrid}
          updateWidgetMsg={updateWidgetMsg}
          selectedTabIndex={selectedTabIndex}
          setSelectedTabIndex={setSelectedTabIndex}
          tempTabIndexLiveDataGraph={tempTabIndexLiveDataGraph}
          tempTabIndexOverviewInfo={tempTabIndexOverviewInfo}
          tempTabIndexOverviewGraph={tempTabIndexOverviewGraph}
          tempTabIndexLastDayTable={tempTabIndexLastDayTable}
          tempTabIndexLastDayGraph={tempTabIndexLastDayGraph}
          tempTabIndexDefaultGrid={tempTabIndexDefaultGrid}
          isMobile={isMobile}
          scaleValue={scaleValue}
          tabIndexMotor={tabIndexMotor}
          setTabIndexMotor={setTabIndexMotor}
          tabIndexDisplay={tabIndexDisplay}
          setTabIndexDisplay={setTabIndexDisplay}
          tabIndexText={tabIndexText}
          setTabIndexText={setTabIndexText}
          tabIndexCircularProgress={tabIndexCircularProgress}
          setTabIndexCircularProgress={setTabIndexCircularProgress}
          setTabIndexDoughnut={setTabIndexDoughnut}
          tabIndexDoughnut={tabIndexDoughnut}
          setTabIndexSquare={setTabIndexSquare}
          tabIndexSquare={tabIndexSquare}
          tabIndexLines={tabIndexLines}
          setTabIndexLines={setTabIndexLines}
          documentId={documentId}
          vNetPassword={vNetPassword}
          vNetUsername={vNetUsername}
          deviceName={deviceName}
          deviceGroupName={deviceGroupName}
          tagGroupName={tagGroupName}
          tabIndexCircle={tabIndexCircle}
          setTabIndexCircle={setTabIndexCircle}
          tabIndexPolygone={tabIndexPolygone}
          setTabIndexPolygone={setTabIndexPolygone}
          tabIndexPipe={tabIndexPipe}
          setTabIndexPipe={setTabIndexPipe}
          tabIndexSwitch={tabIndexSwitch}
          setTabIndexSwitch={setTabIndexSwitch}
          tabIndexCheckbox={tabIndexCheckbox}
          setTabIndexCheckbox={setTabIndexCheckbox}
          tabIndexRadio={tabIndexRadio}
          setTabIndexRadio={setTabIndexRadio}
          tabIndexSlider={tabIndexSlider}
          setTabIndexSlider={setTabIndexSlider}
          tabIndexLamp={tabIndexLamp}
          setTabIndexLamp={setTabIndexLamp}
          tabIndexPush={tabIndexPush}
          setTabIndexPush={setTabIndexPush}
          tabIndexList={tabIndexList}
          setTabIndexList={setTabIndexList}
          tabIndexLink={tabIndexLink}
          setTabIndexLink={setTabIndexLink}
          tabIndexClock={tabIndexClock}
          setTabIndexClock={setTabIndexClock}
        />
      ) : (
        <div className={styles.swrap}>
          <div className={styles.navigates}>
            <a href="/"> Dashboard</a> &gt; {projectName} &gt; {isPath}
          </div>
          <div className={styles.superWrapper}>
            <div className={styles.wrapperRight}>
              <div
                className={styles.wrapper}
                ref={containerRef}
                style={{ overflow: `${isMobile ? 'auto' : ''}` }}
              >
                {generateImage()}
                {generateDevice()}
                {generateDisplay()}
                {generateController()}
                {generateIO()}
                {generateFlowMeter()}
                {generateEnergyMeter()}
                {generateMotor()}
                {generateLineChart()}
                {generatePieChart()}
                {generateBarChart()}
                {generateHistogram()}
                {generateGauge()}
                {generateProgressBar()}
                {generateGrid()}
                {generateTable()}
                {generateText()}
                {generateCircularProgress()}
                {generateDoughnut()}
                {generateLines()}
                {generateSquare()}
                {generateCircle()}
                {generatePolygone()}
                {generatePipe()}
                {generateSwitch()}
                {generateCheckbox()}
                {generateRadio()}
                {generateSlider()}
                {generateLamp()}
                {generatePush()}
                {generateLink()}
                {generateClock()}

                <Tabs
                  isFitted
                  size="sm"
                  variant="enclosed"
                  defaultIndex={selectedTabIndex}
                  style={
                    isMobile ? { minWidth: '920px', position: 'static' } : {}
                  }
                >
                  <div className={styles.tabList}>
                    <TabList
                      style={
                        isMobile
                          ? {
                            border: 'none',
                            display: 'flex',
                            flexWrap: 'wrap',
                          }
                          : { border: 'none' }
                      }
                    >
                      {tabNames && tabNames.length > 0 ? (
                        tabNames.map((tabName, tabIndex) => {
                          return (
                            <>
                              <Tab
                                style={{ border: 'none' }}
                                key={tabIndex}
                                onClick={() =>
                                  handleTabIndex(tabIndex, tabName)
                                }
                              >
                                {tabName}
                              </Tab>
                            </>
                          );
                        })
                      ) : (
                        <Tab style={{ border: 'none' }}>No Tabs Available</Tab>
                      )}
                    </TabList>
                    {/* <div className={styles.gridContainer}>
                    </div> */}
                  </div>

                  <TabPanels>
                    <TabPanel>
                      <Overview
                        isPath={isPath}
                        uniqueProjectId={uniqueProjectId}
                        data={data}
                        socketData={socketData}
                        images={images}
                        openNewPage={openNewPage}
                        tabIndexOverviewInfo={tabIndexOverviewInfo}
                        tempTabIndexOverviewInfo={tempTabIndexOverviewInfo}
                        selectedTabIndex={selectedTabIndex}
                        tabIndexOverviewGraph={tabIndexOverviewGraph}
                        tempTabIndexOverviewGraph={tempTabIndexOverviewGraph}
                        isMobile={isMobile}
                        scaleValue={scaleValue}
                      />
                    </TabPanel>
                    <TabPanel style={{ height: '68vh' }}>
                      <Channels
                        isPath={isPath}
                        data={data}
                        socketData={socketData}
                        tabIndexDefaultGrid={tabIndexDefaultGrid}
                        tempTabIndexDefaultGrid={tempTabIndexDefaultGrid}
                        selectedTabIndex={selectedTabIndex}
                        openNewPage={openNewPage}
                        isMobile={isMobile}
                        scaleValue={scaleValue}
                      />
                    </TabPanel>
                    <TabPanel style={{ height: '68vh' }}>
                      <LiveData
                        isPath={isPath}
                        uniqueProjectId={uniqueProjectId}
                        data={data}
                        socketData={socketData}
                        tabIndexLiveDataGraph={tabIndexLiveDataGraph}
                        setTabIndexLiveDataGraph={setTabIndexLiveDataGraph}
                        selectedTabIndex={selectedTabIndex}
                        openNewPage={openNewPage}
                        tempTabIndexLiveDataGraph={tempTabIndexLiveDataGraph}
                        scaleValue={scaleValue}
                        isMobile={isMobile}
                      />
                    </TabPanel>
                    <TabPanel>
                      <Day1
                        isPath={isPath}
                        data={data}
                        socketData={socketData}
                        openNewPage={openNewPage}
                        selectedTabIndex={selectedTabIndex}
                        tabIndexLastDayTable={tabIndexLastDayTable}
                        tabIndexLastDayGraph={tabIndexLastDayGraph}
                        tempTabIndexLastDayGraph={tempTabIndexLastDayGraph}
                        tempTabIndexLastDayTable={tempTabIndexLastDayTable}
                        isMobile={isMobile}
                        scaleValue={scaleValue}
                      />
                    </TabPanel>
                  </TabPanels>
                </Tabs>
              </div>
            </div>
          </div>
          {userPermission.editView && !isMobile && (
            <button className={styles.updateViewBtn} onClick={handleNewPage}>
              Update View
            </button>
          )}
          {isMobile && (
            <div className={styles.scaleBtnWrapper}>
              <button className={styles.zoomInBtn} onClick={increaseScale}>
                +
              </button>
              <button className={styles.zoomOutBtn} onClick={decreaseScale}>
                -
              </button>
            </div>
          )}
        </div>
      )}

      {isChannelUpdateModal && (
        <ChangeValueModal
          setIsChannelUpdateModal={setIsChannelUpdateModal}
          vNetSid={vNetSid}
          selectedWidgetChannel={selectedWidgetChannel}
          setUpdateValue={setUpdateValue}
          updateValue={updateValue}
          tagMap={tagMap}
          dispatch={dispatch}
          currentDevice={currentDevice}
          setTableData={setTableData}
        />
      )}
    </>
  );
}

export default Project;
